webpackJsonp([1],{

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(280);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	modules: {
		mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
	},
	actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
}));

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_HEAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_FOOTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_PAGE_TITLE; });

var UPDATE_HEAD = 'UPDATE_HEAD';

var UPDATE_LOADING = 'UPDATE_LOADING';

var UPDATE_FOOTER = 'UPDATE_FOOTER';

var UPDATE_PAGE_TITLE = 'UPDATE_PAGE_TITLE';

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rwtz.6c81ae3.jpg";

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_plugins_ajax_index_js__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_plugins_alert_index_js__ = __webpack_require__(310);







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vux_src_plugins_alert_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vux_src_plugins_ajax_index_js__["a" /* default */]);

var baseAjax = function baseAjax(param) {
  var defaultParam = {
    data: param.data || {},
    params: param.params || {},
    url: param.url,
    type: param.type || 'get',
    timeout: param.timeout || 5000,
    showLoading: false
  };

  if (param.showLoading) {
    __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit('UPDATE_LOADING', true);
  }

  __WEBPACK_IMPORTED_MODULE_3_vux_src_plugins_ajax_index_js__["a" /* default */].$http.request({
    baseURL: defaultParam.baseURL,
    method: defaultParam.type,
    url: defaultParam.url,
    data: defaultParam.data,
    params: defaultParam.params,
    timeout: defaultParam.timeout,
    headers: defaultParam.headers
  }).then(function (response) {
    __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit('UPDATE_LOADING', false);

    param.success(response.data);
  }).catch(function (erro) {
    __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit('UPDATE_LOADING', false);
    console.log(erro);
  });
};

var baseFun = {
  localSet: function localSet(obj, key) {
    var newObj = obj;
    var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newObj);
    localStorage.setItem(key, str);
  },
  localGet: function localGet(key) {
    var str = localStorage.getItem(key);
    return JSON.parse(str);
  },
  localClear: function localClear(key) {
    localStorage.removeItem(key);
  },
  getQueryString: function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  baseFun: baseFun,
  baseAjax: baseAjax
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_memberHome__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_memberHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_memberHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_member_activities_activityIndex__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_member_activities_activityIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_member_activities_activityIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_member_mine_mine__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_member_mine_mine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_member_mine_mine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_login__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Dtask__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Dtask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_Dtask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Ttask__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Ttask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_Ttask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Ttaskwai__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Ttaskwai___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Ttaskwai__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Shouye__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Shouye___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_Shouye__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Tupload__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Tupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_Tupload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_studyRanking__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_studyRanking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_studyRanking__);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',

  routes: [{ path: '/', redirect: '/login' }, { path: '*', redirect: '/memberHome/dashbord' }, { path: '/login', component: __WEBPACK_IMPORTED_MODULE_5__views_login___default.a }, {
    path: '/dtask',
    name: 'Dtask',
    component: __WEBPACK_IMPORTED_MODULE_6__views_Dtask___default.a
  }, {
    path: '/ttask',
    name: 'Ttask',
    component: __WEBPACK_IMPORTED_MODULE_7__views_Ttask___default.a
  }, {
    path: '/ttaskwai',
    name: 'Ttaskwai',
    component: __WEBPACK_IMPORTED_MODULE_8__views_Ttaskwai___default.a
  }, {
    path: '/studyRanking',
    name: 'studyRanking',
    component: __WEBPACK_IMPORTED_MODULE_11__views_studyRanking___default.a
  }, {
    path: '/shouye',
    name: 'Shouye',
    component: __WEBPACK_IMPORTED_MODULE_9__views_Shouye___default.a
  }, {
    path: '/tupload',
    name: 'Tupload',
    component: __WEBPACK_IMPORTED_MODULE_10__views_Tupload___default.a
  }, {
    path: '/memberHome',
    name: 'memberHome',
    component: __WEBPACK_IMPORTED_MODULE_2__components_memberHome___default.a,
    children: [{
      path: '/memberHome/dashbord',
      name: 'dashbord',
      component: __WEBPACK_IMPORTED_MODULE_3__components_member_activities_activityIndex___default.a
    }, {
      path: '/memberHome/mine',
      name: 'mine',
      component: __WEBPACK_IMPORTED_MODULE_4__components_member_mine_mine___default.a
    }]
  }]

});
router.beforeEach(function (to, from, next) {
  console.log(1);
  console.log(to);
  console.log(1);
  console.log(from.fullPath);
  console.log(2);
  console.log(sessionStorage.getItem("wxid"));
  if (from.fullPath === '/' || to.fullPath === '/Tupload' || to.fullPath === '/Ttaskwai' || to.fullPath === '/shouye') {
    next();
  } else {
    if (localStorage.getItem('wxid') === null) {
      alert('无权查看');
    } else {
      next();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 230:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(412)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(545),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPopper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return offset_default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__);






function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== "[object Window]") {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(" ");
  }
  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}

function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;
  return (/auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX)
  );
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}

function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}

function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}

function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode);
    if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || ["transform", "perspective"].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}

var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var placements = [].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function order(modifiers) {
  var map = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a();
  var visited = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn2) {
  var pending;
  return function () {
    if (!pending) {
      pending = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve().then(function () {
          pending = void 0;
          resolve(fn2());
        });
      });
    }
    return pending;
  };
}

function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(modifier), VALID_PROPERTIES).filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case "name":
          if (typeof modifier.name !== "string") {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', '"' + String(modifier.name) + '"'));
          }
          break;
        case "enabled":
          if (typeof modifier.enabled !== "boolean") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', '"' + String(modifier.enabled) + '"'));
          }
          break;
        case "phase":
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(", "), '"' + String(modifier.phase) + '"'));
          }
          break;
        case "fn":
          if (typeof modifier.fn !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', '"' + String(modifier.fn) + '"'));
          }
          break;
        case "effect":
          if (modifier.effect != null && typeof modifier.effect !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', '"' + String(modifier.fn) + '"'));
          }
          break;
        case "requires":
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', '"' + String(modifier.requires) + '"'));
          }
          break;
        case "requiresIfExists":
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', '"' + String(modifier.requiresIfExists) + '"'));
          }
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + modifier.name + '" modifier, valid properties are ' + VALID_PROPERTIES.map(function (s) {
            return '"' + s + '"';
          }).join(", ") + '; but "' + key + '" was provided.');
      }
      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn2) {
  var identifiers = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a();
  return arr.filter(function (item) {
    var identifier = fn2(item);
    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function getBasePlacement(placement) {
  return placement.split("-")[0];
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, existing, current, {
      options: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, existing.options, current.options),
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(merged).map(function (key) {
    return merged[key];
  });
}

function getVariation(placement) {
  return placement.split("-")[1];
}

function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
      default:
    }
  }
  return offsets;
}

var INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultOptions, state.options, options2);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        if (true) {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);
          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === "flip";
            });
            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
            }
          }
          var _getComputedStyle = getComputedStyle(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft;
          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
          }
        }
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements,
            reference2 = _state$elements.reference,
            popper2 = _state$elements.popper;
        if (!areValidElements(reference2, popper2)) {
          if (true) {
            console.error(INVALID_ELEMENT_ERROR);
          }
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference2, getOffsetParent(popper2), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper2)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, modifier.data);
        });
        var __debug_loops__ = 0;
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (true) {
            __debug_loops__ += 1;
            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index],
              fn2 = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      update: debounce(function () {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference, popper)) {
      if (true) {
        console.error(INVALID_ELEMENT_ERROR);
      }
      return instance;
    }
    instance.setOptions(options).then(function (state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options2 = _ref3$options === void 0 ? {} : _ref3$options,
            effect3 = _ref3.effect;
        if (typeof effect3 === "function") {
          var cleanupFn = effect3({
            state: state,
            name: name,
            instance: instance,
            options: options2
          });
          var noopFn = function noopFn2() {};
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}

var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners_default = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {},
  effect: effect,
  data: {}
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
var popperOffsets_default = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};

var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);
      if (getComputedStyle(offsetParent).position !== "static" && position === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
    position: position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  if (true) {
    var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || "";
    if (adaptive && ["transform", "top", "right", "bottom", "left"].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', "\n\n", 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", "\n\n", "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
    }
  }
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.styles.popper, mapToStyles(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.styles.arrow, mapToStyles(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }
  state.attributes.popper = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
var computeStyles_default = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};

function applyStyles(_ref) {
  var state = _ref.state;
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(element.style, style);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(attributes).forEach(function (name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.elements.arrow.style, initialStyles.arrow);
  }
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style = styleProperties.reduce(function (style2, property) {
        style2[property] = "";
        return style2;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(element.style, style);
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles_default = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect2,
  requires: ["computeStyles"]
};

var defaultModifiers = [eventListeners_default, popperOffsets_default, computeStyles_default, applyStyles_default];
var createPopper = popperGenerator({
  defaultModifiers: defaultModifiers
});

function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset2 === "function" ? offset2(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, rects, {
    placement: placement
  })) : offset2,
      skidding = _ref[0],
      distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
}
var offset_default = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};


/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fastclick__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_memberRouter_js__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_js_baseFun_js__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_store__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_base_css__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_css_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vant__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vant_lib_index_css__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vant_lib_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vant_lib_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_axios__);
















__WEBPACK_IMPORTED_MODULE_1_fastclick___default.a.attach(document.body);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.baseFun = __WEBPACK_IMPORTED_MODULE_5__assets_js_baseFun_js__["a" /* default */].baseFun;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.baseAjax = __WEBPACK_IMPORTED_MODULE_5__assets_js_baseFun_js__["a" /* default */].baseAjax;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$axios = __WEBPACK_IMPORTED_MODULE_12_axios___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$httpUrl = 'http://www.qlslj.cn:8989';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$httpUrl2 = 'http://www.qlslj.cn:8989';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vant__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui___default.a);
var globalVm = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
   router: __WEBPACK_IMPORTED_MODULE_4__router_memberRouter_js__["a" /* default */],
   el: '#app',
   store: __WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* default */],
   template: '<App/>',
   components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data__ = __webpack_require__(149);



/* harmony default export */ __webpack_exports__["a"] = ({

	UPDATE_HEAD: function UPDATE_HEAD(_ref) {
		var commit = _ref.commit;

		commit(__WEBPACK_IMPORTED_MODULE_0__data__["a" /* UPDATE_HEAD */]);
	},
	UPDATE_LOADING: function UPDATE_LOADING(_ref2) {
		var commit = _ref2.commit;

		commit(__WEBPACK_IMPORTED_MODULE_0__data__["b" /* UPDATE_LOADING */]);
	},
	UPDATE_FOOTER: function UPDATE_FOOTER(_ref3) {
		var commit = _ref3.commit;

		commit(__WEBPACK_IMPORTED_MODULE_0__data__["c" /* UPDATE_FOOTER */]);
	},
	UPDATE_PAGE_TITLE: function UPDATE_PAGE_TITLE(_ref4) {
		var commit = _ref4.commit;

		commit(__WEBPACK_IMPORTED_MODULE_0__data__["d" /* UPDATE_PAGE_TITLE */]);
	}
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(149);


var _mutations;



var state = {
	headShow: true,
	loading: false,
	footerShow: true,
	pageTitle: '首页'
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__data__["a" /* UPDATE_HEAD */], function (state, type) {
	state.headShow = type;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__data__["b" /* UPDATE_LOADING */], function (state, type) {
	state.loading = type;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__data__["c" /* UPDATE_FOOTER */], function (state, type) {
	state.footerShow = type;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__data__["d" /* UPDATE_PAGE_TITLE */], function (state, type) {
	state.pageTitle = type;
}), _mutations);

var getters = {
	headShow: function headShow(state) {
		return state.headShow;
	},
	loading: function loading(state) {
		return state.loading;
	},
	footerShow: function footerShow(state) {
		return state.footerShow;
	},
	pageTitle: function pageTitle(state) {
		return state.pageTitle;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations,
	getters: getters
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'alert',
  components: {
    XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__badge__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__badge__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tabbar-item',
  components: {
    Badge: __WEBPACK_IMPORTED_MODULE_1__badge___default.a
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__ = __webpack_require__(151);




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_router__ = __webpack_require__(150);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__libs_router__["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_prevent_body_scroll__ = __webpack_require__(308);




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_prevent_body_scroll__["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_blazy__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_blazy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_blazy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_webp_support__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_mixin_uuid__ = __webpack_require__(305);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-img',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__libs_mixin_uuid__["a" /* default */]],
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.init);
  },

  methods: {
    init: function init() {
      var _this = this;

      this.blazy && this.blazy.destroy();
      this.$el.src = this.defaultSrc;
      this.$el.className = this.$el.className.replace('b-loaded', '');

      this.blazy = new __WEBPACK_IMPORTED_MODULE_0_vux_blazy___default.a({
        scroller: this.scroller,
        container: this.container,
        selector: '#vux-ximg-' + this.uuid,
        offset: _this.offset,
        errorClass: _this.errorClass,
        successClass: _this.successClass,
        separator: _this.separator,
        success: function success(ele) {
          _this.$emit('on-success', _this.src, ele);
        },
        error: function error(ele, msg) {
          _this.$emit('on-error', _this.src, ele, msg);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$el.setAttribute('id', 'vux-ximg-' + this.uuid);
    this.$nextTick(function () {
      setTimeout(function () {
        _this2.init();
      }, _this2.delay);
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_webp_support__["a" /* detectWebp */])();
  },

  computed: {
    currentSrc: function currentSrc() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_webp_support__["b" /* isSupported */])() && this.webpSrc) {
        return this.webpSrc;
      }
      return this.src;
    }
  },
  props: {
    src: String,
    webpSrc: String,
    defaultSrc: {
      type: String,
      default: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    },
    errorClass: String,
    successClass: String,
    offset: {
      type: Number,
      default: 100
    },
    scroller: Object,
    container: String,
    delay: {
      type: Number,
      default: 0
    },
    separator: String
  },
  watch: {
    src: function src(val) {
      this.init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.blazy && this.blazy.destroy();
    this.blazy = null;
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.init);
  }
});

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_tabbar_tabbar_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_tabbar_tabbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_components_tabbar_tabbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_icon_index_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_icon_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_icon_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_tabbar_tabbar_item_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_tabbar_tabbar_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_tabbar_tabbar_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_loading_index_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_view_box_index_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_view_box_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_view_box_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(45);












/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['headShow', 'loading', 'footerShow', 'pageTitle']),
  data: function data() {
    var data = {};
    return data;
  },
  mounted: function mounted() {},

  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_6_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  components: {
    Tabbar: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_tabbar_tabbar_vue___default.a,
    TabbarItem: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_tabbar_tabbar_item_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_loading_index_vue___default.a,
    ViewBox: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_view_box_index_vue___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_icon_index_vue___default.a
  }
});

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_tabbar_tabbar_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_tabbar_tabbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_tabbar_tabbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_tabbar_tabbar_item_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_tabbar_tabbar_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_tabbar_tabbar_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_button_index_vue__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_img_index_vue__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_img_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_img_index_vue__);


var _mounted$computed$dat;







/* harmony default export */ __webpack_exports__["default"] = (_mounted$computed$dat = {
  mounted: function mounted() {

    this.loadLatest();
    this.$store.commit('UPDATE_PAGE_TITLE', this.titles);
  },

  computed: {},
  data: function data() {
    return {
      daiwannum: 0,
      shenghenum: 0,
      yiwannum: 0,
      chaoqinum: 0,
      tuihuinum: 0,
      num: 2,
      itemList: '',
      titles: '',
      infoShow: false,
      tanchukuang: '',
      totalData: [],
      urls: [],
      filelist: [],
      filelist1: [],
      filelist2: [],
      filelist3: [],
      filelist4: [],
      filelist5: [],
      filelist6: [],
      imgfile: [],
      imgfile1: [],
      imgfile2: [],
      imgfile3: [],
      imgfile4: [],
      imgfile5: [],
      imgfile6: [],
      fileList2: [{ url: 'https://img.yzcdn.cn/vant/leaf.jpg' }, { url: 'https://cloud-image', isImage: true }],
      imgszs: [],

      test: {
        "height": '',
        "overflow": "scroll"

      }

    };
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mounted$computed$dat, 'mounted', function mounted() {
  this.doPage(localStorage.getItem("wxid"));
  this.doPage1(localStorage.getItem("wxid"));
  this.doPage2(localStorage.getItem("wxid"));
  this.doPage3(localStorage.getItem("wxid"));
  this.doPage4(localStorage.getItem("wxid"));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mounted$computed$dat, 'methods', {
  afterRead: function afterRead(files, detail) {
    files.forEach(function (element) {
      element.rate = 10;
      setTimeout(function () {
        element.status = null;
      }, 2000);
    });
  },
  dianzan: function dianzan(item) {
    console.log("点赞");
    if (_.isEmpty(item)) {
      console.log("点赞111");
    } else {
      console.log("点赞222");
      return item.includes('点赞');
    }
  },
  zhuangfa: function zhuangfa(item) {
    console.log("转发");
    if (_.isEmpty(item)) {} else {

      return item.includes('转发');
    }
  },
  zaikan: function zaikan(item) {
    console.log("在看");
    if (_.isEmpty(item)) {} else {

      return item.includes('在看');
    }
  },
  pinglun: function pinglun(item) {
    console.log("评论");
    if (_.isEmpty(item)) {} else {

      return item.includes('评论');
    }
  },
  jubao: function jubao(item) {
    console.log("举报");
    if (_.isEmpty(item)) {} else {

      return item.includes('举报');
    }
  },
  guanzhu: function guanzhu(item) {
    console.log("关注");
    if (_.isEmpty(item)) {} else {

      return item.includes('关注');
    }
  },
  toupiao: function toupiao(item) {
    console.log("投票");
    if (_.isEmpty(item)) {} else {

      return item.includes('投票');
    }
  },
  tiao: function tiao(title, id, demand, bumen, urls) {
    console.log(title);
    this.$router.push({ name: 'Ttask', params: { titles: title, id: id, demand: demand, bumen: bumen, urls: urls } });
  },
  open: function open(item) {
    console.log("进入跳转");
    var externalUrl = this.tanchukuang.url;
    console.log(item);

    window.location.href = item;
  },
  listDes: function listDes(item) {
    var _this = this;

    console.log(item);
    this.tanchukuang = item;

    var strArr = item.url;

    console.log(112233);
    console.log(strArr);
    console.log(strArr.split(','));
    console.log(112233);
    strArr.substring(0, strArr.length - 1);

    this.urls = strArr.substring(0, strArr.length - 1).split(',');

    if (item.demand.includes('点赞')) {
      this.imgfile = item.example_liked_img.split(',');
      this.imgfile.forEach(function (item, index) {
        var newarr = _this.$httpUrl + item;
        _this.$set(_this.filelist, index, { url: newarr });
      });
    }
    if (item.demand.includes('在看')) {
      this.imgfile1 = item.example_watching_img.split(',');
      this.imgfile1.forEach(function (item, index) {
        var newarr1 = _this.$httpUrl + item;
        _this.$set(_this.filelist1, index, { url: newarr1 });
      });
    }
    if (item.demand.includes('转发')) {
      this.imgfile2 = item.example_transmit_img.split(',');
      this.imgfile2.forEach(function (item, index) {
        var newarr2 = _this.$httpUrl + item;
        _this.$set(_this.filelist2, index, { url: newarr2 });
      });
    }
    if (item.demand.includes('评论')) {
      this.imgfile3 = item.example_comment_img.split(',');
      this.imgfile3.forEach(function (item, index) {
        var newarr3 = _this.$httpUrl + item;
        _this.$set(_this.filelist3, index, { url: newarr3 });
      });
    }
    if (item.demand.includes('举报')) {
      this.imgfile4 = item.example_report_img.split(',');
      this.imgfile4.forEach(function (item, index) {
        var newarr3 = _this.$httpUrl + item;
        _this.$set(_this.filelist4, index, { url: newarr3 });
      });
    }
    if (item.demand.includes('关注')) {
      this.imgfile5 = item.example_gz_img.split(',');
      this.imgfile5.forEach(function (item, index) {
        var newarr3 = _this.$httpUrl + item;
        _this.$set(_this.filelist5, index, { url: newarr3 });
      });
    }
    if (item.demand.includes('投票')) {
      this.imgfile6 = item.example_tp_img.split(',');
      this.imgfile6.forEach(function (item, index) {
        var newarr3 = _this.$httpUrl + item;
        _this.$set(_this.filelist6, index, { url: newarr3 });
      });
    }

    this.test.height = document.body.clientHeight - 260 + 'px';
    console.log(this.test, '------');
    this.infoShow = true;
  },
  task: function task(titles) {

    console.log(titles);
    this.titles = titles;

    sessionStorage.setItem("pageTitle", this.titles);
    this.$router.push({ name: 'Dtask', query: { titles: this.titles } });
  },
  loadLatest: function loadLatest() {
    var self = this;
    this.baseAjax({
      url: '../../../static/basicData/latestActivity.json',
      showLoading: true,
      success: function success(data) {
        console.log(data);
        self.itemList = data.returnObject;
      }
    });
  },
  doPage: function doPage(wxid) {
    var _this2 = this;

    this.$axios.get(this.$httpUrl + '/daren/personwork/list?ryid=' + wxid + '&status=' + '未提交未审核' + '&authority=普通员工').then(function (res) {
      return res.data;
    }).then(function (res) {
      console.log(res);
      _this2.totalData = res.rows;
      _this2.daiwannum = res.total;
    });
  },
  doPage1: function doPage1(wxid) {
    var _this3 = this;

    this.$axios.get(this.$httpUrl + '/daren/personwork/list?ryid=' + wxid + '&status=' + '已提交未审核' + '&authority=普通员工').then(function (res) {
      return res.data;
    }).then(function (res) {
      console.log(res);

      _this3.shenghenum = res.total;
    });
  },
  doPage2: function doPage2(wxid) {
    var _this4 = this;

    this.$axios.get(this.$httpUrl + '/daren/personwork/list?ryid=' + wxid + '&status=' + '已提交已通过' + '&authority=普通员工').then(function (res) {
      return res.data;
    }).then(function (res) {
      console.log(res);

      _this4.yiwannum = res.total;
    });
  },
  doPage3: function doPage3(wxid) {
    var _this5 = this;

    this.$axios.get(this.$httpUrl + '/daren/personwork/list?ryid=' + wxid + '&status=' + '超期' + '&authority=普通员工').then(function (res) {
      return res.data;
    }).then(function (res) {
      console.log(res);

      _this5.chaoqinum = res.total;
    });
  },
  doPage4: function doPage4(wxid) {
    var _this6 = this;

    this.$axios.get(this.$httpUrl + '/daren/personwork/list?ryid=' + wxid + '&status=' + '已提交未通过' + '&authority=普通员工').then(function (res) {
      return res.data;
    }).then(function (res) {
      console.log(res);

      _this6.tuihuinum = res.total;
    });
  },
  getimg: function getimg(img) {
    console.log("img");
    console.log(img);
    console.log("img");
    var imgs = img.split(',');

    return this.$httpUrl2 + imgs[0];
  },
  getimg2: function getimg2(img) {
    console.log(img);
    return this.$httpUrl2 + img;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mounted$computed$dat, 'components', {
  Tabbar: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_tabbar_tabbar_vue___default.a,
  TabbarItem: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_tabbar_tabbar_item_vue___default.a,
  XHeader: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default.a,
  XButton: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_button_index_vue___default.a,
  XImg: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_img_index_vue___default.a
}), _mounted$computed$dat);

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_tabbar_tabbar_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_tabbar_tabbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_tabbar_tabbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_icon_index_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_icon_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_icon_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_tabbar_tabbar_item_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_tabbar_tabbar_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_tabbar_tabbar_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_loading_index_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_view_box_index_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_view_box_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_view_box_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vant__ = __webpack_require__(85);











/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    headShow: function headShow() {
      return this.$store.getters.headShow;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    footerShow: function footerShow() {
      return this.$store.getters.footerShow;
    },
    pageTitle: function pageTitle() {

      return this.$route.query.titles;
    },
    paginatedData: function paginatedData() {
      console.log("处理分页");
      var start = (this.currentPage - 1) * this.pageSize;
      console.log(start);
      var end = start + this.pageSize;
      console.log(end);
      return this.totalData.slice(start, end);
    }
  },
  components: {
    Tabbar: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_tabbar_tabbar_vue___default.a,
    TabbarItem: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_tabbar_tabbar_item_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_loading_index_vue___default.a,
    ViewBox: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_view_box_index_vue___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_icon_index_vue___default.a
  },
  data: function data() {
    return {

      likedfile: [],
      transmitfile: [],
      watchingfile: [],
      commentfile: [],
      reportfile: [],
      gzfile: [],
      tpfile: [],
      totalData: [],
      uploader: [],

      currentPage: 1,

      pageSize: 4,

      filelist: [],
      filelist1: [],
      filelist2: [],
      filelist3: [],
      filelist4: [],
      filelist5: [],
      filelist6: [],

      imgfile: [],
      imgfile1: [],
      imgfile2: [],
      imgfile3: [],
      imgfile4: [],
      imgfile5: [],
      pageCount: 0,
      searchValue: '',
      infoShow: false,
      infoShow1: false,
      sfxs: 1,
      statuss: '',
      urls: [],
      imgszs: [],
      tanchukuang: [],
      test: {
        "height": '',
        "overflow": "scroll"
      }
    };
  },
  mounted: function mounted() {

    console.log("钩子函数");
    console.log(sessionStorage.getItem("pageTitle"));
    console.log(localStorage.getItem("wxid"));

    if (this.$route.query.titles === "待完任务") {
      this.statuss = "未提交未审核";
      this.sfxs = 0;
    } else if (this.$route.query.titles === "已完任务") {
      this.statuss = "已提交已通过";
      this.sfxs = 1;
    } else if (this.$route.query.titles === "超期任务") {
      this.statuss = "超期";
      this.sfxs = 3;
    } else if (this.$route.query.titles === "退回任务") {
      this.statuss = "已提交未通过";
      this.sfxs = 2;
    } else if (this.$route.query.titles === "审核任务") {
      this.statuss = "已提交未审核";
      this.sfxs = 1;
    }

    this.doPage(localStorage.getItem("wxid"));
    this.$store.commit('UPDATE_PAGE_TITLE', this.$route.query.titles);
  },

  methods: {
    afterRead: function afterRead(files, detail) {
      files.forEach(function (element) {
        element.rate = 10;
        setTimeout(function () {
          element.status = null;
        }, 2000);
      });
    },
    dianzan: function dianzan(item) {
      console.log("点赞");
      if (_.isEmpty(item)) {
        console.log("点赞111");
      } else {
        console.log("点赞222");
        return item.includes('点赞');
      }
    },
    zhuangfa: function zhuangfa(item) {
      console.log("转发");
      if (_.isEmpty(item)) {} else {

        return item.includes('转发');
      }
    },
    zaikan: function zaikan(item) {
      console.log("在看");
      if (_.isEmpty(item)) {} else {

        return item.includes('在看');
      }
    },
    pinglun: function pinglun(item) {
      console.log("评论");
      if (_.isEmpty(item)) {} else {

        return item.includes('评论');
      }
    },
    jubao: function jubao(item) {
      console.log("举报");
      if (_.isEmpty(item)) {} else {

        return item.includes('举报');
      }
    },
    guanzhu: function guanzhu(item) {
      console.log("关注");
      if (_.isEmpty(item)) {} else {

        return item.includes('关注');
      }
    },
    toupiao: function toupiao(item) {
      console.log("投票");
      if (_.isEmpty(item)) {} else {

        return item.includes('投票');
      }
    },
    tiao: function tiao(title, id, demand, bumen, urls) {

      console.log(title);
      this.$router.push({ name: 'Ttask', params: { titles: title, id: id, demand: demand, bumen: bumen, urls: urls } });
    },
    open: function open(item) {
      console.log("进入跳转");
      var externalUrl = this.tanchukuang.url;
      console.log(item);

      window.location.href = item;
    },
    getimg: function getimg(img) {

      var imgs = img.split(',');

      return this.$httpUrl2 + imgs[0];
    },
    getimg2: function getimg2(img) {
      console.log(img);
      return this.$httpUrl2 + img;
    },
    listDes: function listDes(item) {
      var _this = this;

      console.log(item);
      this.tanchukuang = item;

      var strArr = item.url;

      console.log(112233);
      console.log(strArr);
      console.log(strArr.split(','));
      console.log(112233);
      strArr.substring(0, strArr.length - 1);

      this.urls = strArr.substring(0, strArr.length - 1).split(',');

      this.test.height = document.body.clientHeight - 280 + 'px';
      if (this.sfxs === 0) {
        console.log("我进来了1112233");
        console.log(item.demand);
        if (item.demand.includes('点赞')) {
          console.log("我进来了1112233点赞");
          this.imgfile = item.example_liked_img.split(',');
          this.imgfile.forEach(function (item, index) {
            var newarr = _this.$httpUrl + item;
            _this.$set(_this.filelist, index, { url: newarr });
          });
        }
        if (item.demand.includes('在看')) {
          console.log("我进来了1112233在看");
          this.imgfile1 = item.example_watching_img.split(',');
          this.imgfile1.forEach(function (item, index) {
            var newarr1 = _this.$httpUrl + item;
            _this.$set(_this.filelist1, index, { url: newarr1 });
          });
        }
        if (item.demand.includes('转发')) {
          console.log("我进来了1112233转发");
          this.imgfile2 = item.example_transmit_img.split(',');
          this.imgfile2.forEach(function (item, index) {
            var newarr2 = _this.$httpUrl + item;
            _this.$set(_this.filelist2, index, { url: newarr2 });
          });
        }
        if (item.demand.includes('评论')) {
          console.log("我进来了1112233评论");
          this.imgfile3 = item.example_comment_img.split(',');
          this.imgfile3.forEach(function (item, index) {
            var newarr3 = _this.$httpUrl + item;
            _this.$set(_this.filelist3, index, { url: newarr3 });
          });
        }
        if (item.demand.includes('举报')) {
          console.log("我进来了1112233举报");
          this.imgfile3 = item.example_report_img.split(',');
          this.imgfile3.forEach(function (item, index) {
            var newarr3 = _this.$httpUrl + item;
            _this.$set(_this.filelist4, index, { url: newarr3 });
          });
        }
        if (item.demand.includes('关注')) {
          console.log("我进来了1112233关注");
          this.imgfile4 = item.example_gz_img.split(',');
          this.imgfile4.forEach(function (item, index) {
            var newarr3 = _this.$httpUrl + item;
            _this.$set(_this.filelist5, index, { url: newarr3 });
          });
        }
        if (item.demand.includes('投票')) {
          console.log("我进来了1112233投票");
          this.imgfile5 = item.example_tp_img.split(',');
          this.imgfile5.forEach(function (item, index) {
            var newarr3 = _this.$httpUrl + item;
            _this.$set(_this.filelist6, index, { url: newarr3 });
          });
        }
        this.infoShow = true;
      } else if (this.sfxs === 1 || this.sfxs === 2) {
        console.log(this.sfxs, "this.sfxs");

        if (item.demand.includes('点赞')) {
          console.log("我进来了1112233点赞");
          this.imgfile = item.likedfile.split(',');
          this.imgfile.forEach(function (item, index) {
            console.log(item, "item");
            var newlikedfile = _this.$httpUrl2 + item;

            _this.$set(_this.likedfile, index, { url: newlikedfile });
          });
        }
        if (item.demand.includes('在看')) {
          console.log("我进来了1112233在看");
          this.imgfile1 = item.watchingfile.split(',');
          this.imgfile1.forEach(function (item, index) {

            var newwatchingfile = _this.$httpUrl2 + item;
            _this.$set(_this.watchingfile, index, { url: newwatchingfile });
          });
        }
        if (item.demand.includes('转发')) {
          console.log("我进来了1112233转发");
          this.imgfile2 = item.transmitfile.split(',');
          this.imgfile2.forEach(function (item, index) {

            var newtransmitfile = _this.$httpUrl2 + item;
            _this.$set(_this.transmitfile, index, { url: newtransmitfile });
          });
        }
        if (item.demand.includes('评论')) {
          console.log("我进来了1112233评论");
          this.imgfile3 = item.commentfile.split(',');
          this.imgfile3.forEach(function (item, index) {

            var newcommentfile = _this.$httpUrl2 + item;
            _this.$set(_this.commentfile, index, { url: newcommentfile });
          });
        }
        if (item.demand.includes('举报')) {
          console.log("我进来了1112233举报");
          this.imgfile3 = item.reportfile.split(',');
          this.imgfile3.forEach(function (item, index) {

            var newcommentfile = _this.$httpUrl2 + item;
            _this.$set(_this.reportfile, index, { url: newcommentfile });
          });
        }
        if (item.demand.includes('关注')) {
          console.log("我进来了1112233关注1");
          this.imgfile4 = item.gzfile.split(',');
          this.imgfile4.forEach(function (item, index) {
            var newcommentfile = _this.$httpUrl2 + item;
            _this.$set(_this.gzfile, index, { url: newcommentfile });
          });
        }
        if (item.demand.includes('投票')) {
          console.log("我进来了1112233投票1");
          this.imgfile5 = item.tpfile.split(',');
          this.imgfile5.forEach(function (item, index) {
            var newcommentfile = _this.$httpUrl2 + item;
            console.log(newcommentfile, "照片地址");
            _this.$set(_this.tpfile, index, { url: newcommentfile });
          });
        }

        this.uploader = item.commentfile;
        this.infoShow1 = true;
      }
    },
    fetchData2: function fetchData2() {
      console.log("长度");
      console.log(this.totalData.length);
    },
    fetchData: function fetchData() {
      console.log("处理分页2");

      this.totalData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: 100 }, function (_, index) {
        return {
          title: '\u4EFB\u52A1\u6807\u9898' + (index + 1),
          time: '2024-07-2' + (index + 1) + ' 12:00:00'
        };
      });

      console.log(this.totalData.length, 'total');
      console.log("长度：");
      this.pageCount = Math.ceil(this.totalData.length / this.pageSize);
    },
    handlePageChange: function handlePageChange(page) {

      this.currentPage = page;
    },
    doPage: function doPage(wxid) {
      var _this2 = this;

      this.$axios.get(this.$httpUrl + '/daren/personwork/list?ryid=' + wxid + '&status=' + this.statuss + '&authority=普通员工').then(function (res) {
        return res.data;
      }).then(function (res) {
        console.log(res);
        _this2.totalData = res.rows;

        console.log("长度");
        console.log(_this2.totalData.length);
        _this2.pageCount = Math.ceil(_this2.totalData.length / _this2.pageSize);
      });
    }
  }
});

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      name: '',

      paths: []
    };
  },
  mounted: function mounted() {},

  methods: {}
});

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_tabbar_tabbar_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_tabbar_tabbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_tabbar_tabbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_icon_index_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_icon_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_icon_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_tabbar_tabbar_item_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_tabbar_tabbar_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_tabbar_tabbar_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_header_index_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_loading_index_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_view_box_index_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_view_box_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_view_box_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(45);





var _methods;










/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    headShow: function headShow() {
      return this.$store.getters.headShow;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    footerShow: function footerShow() {
      return this.$store.getters.footerShow;
    },
    pageTitle: function pageTitle() {
      return this.$store.getters.pageTitle;
    },
    containsChar1: function containsChar1() {

      console.log(this.demand);
      return this.demand.includes("点赞");
    },
    containsChar2: function containsChar2() {

      return this.demand.includes("评论");
    },
    containsChar3: function containsChar3() {

      return this.demand.includes("转发");
    },
    containsChar4: function containsChar4() {

      return this.demand.includes("在看");
    },
    containsChar5: function containsChar5() {

      return this.demand.includes("举报");
    },
    containsChar6: function containsChar6() {

      return this.demand.includes("关注");
    },
    containsChar7: function containsChar7() {

      return this.demand.includes("投票");
    },
    containsChar8: function containsChar8() {

      if (this.demand.includes("投票") && this.urls === 2) {

        return true;
      } else {
        return false;
      }
    }
  },
  components: {
    Tabbar: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_tabbar_tabbar_vue___default.a,
    TabbarItem: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_tabbar_tabbar_item_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_header_index_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_loading_index_vue___default.a,
    ViewBox: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_view_box_index_vue___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_icon_index_vue___default.a
  },
  data: function data() {
    return {
      taskname: "",
      totalData: [],
      uploader: [],
      uploader2: [],
      uploader3: [],
      uploader4: [],
      uploader5: [],
      uploader6: [],
      uploader7: [],
      uploader8: [],
      notes: "",
      value: "",
      value2: "",
      demand: "",
      bumen: "",
      urls: "",
      showPicker: "",
      columns: [],
      filenames2: [],
      filenames22: [],
      filenames222: [],
      filenames2222: [],
      filenames22222: [],
      filenames222222: [],
      filenames2222222: [],
      filenames22222222: [],
      filedata: "",
      filedatazf: "",
      filedatazk: "",
      filedatadz: "",
      filedatapl: "",
      paths: []
    };
  },
  mounted: function mounted() {
    this.$store.commit("UPDATE_PAGE_TITLE", "任务提交");
    this.showPicker = this.$route.params.titles;
    this.value2 = this.$route.params.id;
    this.demand = this.$route.params.demand;
    this.bumen = this.$route.params.bumen;
    this.urls = this.$route.params.urls.length;
  },

  methods: (_methods = {
    subConfirm: function subConfirm() {
      console.log(this.uploader[0]);

      var time = this.gettime();
      console.log(time);
      this.renwutijiao(time);
    },
    doPage: function doPage(wxid) {
      var _this2 = this;

      this.$axios.get(this.$httpUrl + "/daren/personwork/list?ryid=" + wxid + "&status=" + "未完成").then(function (res) {
        return res.data;
      }).then(function (res) {
        console.log(res);
        _this2.totalData = res.rows;
        _this2.totalData.forEach(function (item) {
          console.log(item.title);
          _this2.$set(_this2.columns, _this2.columns.length, item.title);
        });
      });
    },
    renwutijiao: function renwutijiao(time) {
      var _this3 = this;

      if (this.demand.includes("点赞")) {
        if (this.filenames2.length > 0) {} else {
          console.log(this.filenames2.length);
          alert("有未填项，请完善后再提交1");
          return;
        }
      }
      if (this.demand.includes("评论")) {
        if (this.filenames22.length > 0) {} else {
          console.log(this.filenames22.length);
          alert("有未填项，请完善后再提交2");
          return;
        }
      }
      if (this.demand.includes("转发")) {
        if (this.filenames222.length > 0) {} else {
          console.log(this.filenames222.length);
          alert("有未填项，请完善后再提交3");
          return;
        }
      }
      if (this.demand.includes("在看")) {
        if (this.filenames2222.length > 0) {} else {
          console.log(this.filenames2222.length);
          alert("有未填项，请完善后再提交4");
          return;
        }
      }
      if (this.demand.includes("举报")) {
        if (this.filenames22222.length > 0) {} else {
          console.log(this.filenames22222.length);
          alert("有未填项，请完善后再提交5");
          return;
        }
      }
      if (this.demand.includes("关注")) {
        if (this.filenames222222.length > 0) {} else {
          console.log(this.filenames222222.length);
          alert("有未填项，请完善后再提交6");
          return;
        }
      }
      if (this.demand.includes("投票")) {
        if (this.filenames2222222.length > 0) {} else {
          console.log(this.filenames2222222.length);
          alert("有未填项，请完善后再提交7");
          return;
        }
      }
      if (this.demand.includes("投票2")) {
        if (this.filenames22222222.length > 0) {} else {
          console.log(this.filenames22222222.length);
          alert("有未填项，请完善后再提交8");
          return;
        }
      }

      if (true) {
        this.$axios.put(this.$httpUrl + "/daren/personwork", {
          id: this.value2,
          message: this.notes,
          likedfile: this.filenames2.join(","),
          commentfile: this.filenames22.join(","),
          transmitfile: this.filenames222.join(","),
          watchingfile: this.filenames2222.join(","),
          reportfile: this.filenames22222.join(","),
          gzfile: this.filenames222222.join(","),
          tpfile: this.filenames2222222.join(",") + "," + this.filenames22222222.join(","),
          wctime: time,
          status: "已提交未审核",
          authority: "1"
        }).then(function (res) {
          return res.data;
        }).then(function (res) {
          console.log(res);
          if (res.code === 200) {
            _this3.$router.push("/memberHome/dashbord");
          }
        });
      } else {
        alert("有未填项，请完善后再提交");
      }
    },
    imageCompress: function imageCompress(url, type, size) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var www = 0;
        var hhh = 0;
        if (size > 10000000) {
          console.log(size, "size");
          www = 50;
          hhh = 50;
        } else if (size > 5000000) {
          console.log(size, "size");
          www = 20;
          hhh = 20;
        } else if (size > 3000000) {
          www = 10;
          hhh = 10;
        } else if (size > 1000000) {
          www = 5;
          hhh = 5;
        } else {
          www = 3;
          hhh = 3;
        }
        var img = new Image();
        img.src = url;
        var files = {};
        img.onload = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
          var canvas, context, w, h, base64;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  canvas = document.createElement("canvas");
                  context = canvas.getContext("2d");
                  w = img.width / www;
                  h = img.height / hhh;

                  canvas.width = w;
                  canvas.height = h;
                  context.clearRect(0, 0, 0, w, h);
                  context.drawImage(img, 0, 0, w, h);
                  base64 = canvas.toDataURL(type, 0.9);

                  resolve(base64);

                case 10:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this4);
        }));
      });
    },
    base64ToFile: function base64ToFile(base64, filename, mimeType) {
      var byteCharacters = atob(base64.split(",")[1]);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var blob = new Blob([byteArray], {
        type: mimeType
      });

      var file = new File([blob], filename, {
        type: mimeType
      });

      return file;
    },
    afterRead: function afterRead(files, detail) {
      var _this = this;

      console.log(files.file.size, "压缩前");

      files.content = files.content.replace("data:application/octet-stream;", 'data:image/png;');
      this.filedata = 1;
      var base = files.content;

      var name = this.bumen.replace(/\//g, "") + files.file.name;
      this.imageCompress(files.content, files.file.type, files.file.size).then(function (res) {
        files.content = res;

        var tempFile = _this.base64ToFile(res, name, files.file.type);
        console.log(tempFile, tempFile.size, "压缩后");
        _this.handle(tempFile);
      });
    },
    afterRead2: function afterRead2(files, detail) {

      var _this = this;
      console.log(files.file.size, "压缩前");
      console.log("handle2");
      console.log(files.file);
      files.content = files.content.replace("data:application/octet-stream;", 'data:image/png;');
      this.filedata = 1;
      var base = files.content;

      var name = this.bumen.replace(/\//g, "") + files.file.name;
      this.imageCompress(files.content, files.file.type).then(function (res) {
        files.content = res;
        var tempFile = _this.base64ToFile(res, name, files.file.type);

        console.log(tempFile, tempFile.size, "压缩后");
        _this.handle2(tempFile);
      });
    },
    afterRead3: function afterRead3(files, detail) {
      var _this = this;
      console.log(files.file.size, "压缩前");
      console.log("handle3");
      console.log(files.file);
      files.content = files.content.replace("data:application/octet-stream;", 'data:image/png;');
      this.filedata = 1;
      var base = files.content;

      var name = this.bumen.replace(/\//g, "") + files.file.name;
      this.imageCompress(files.content, files.file.type).then(function (res) {
        files.content = res;

        var tempFile = _this.base64ToFile(res, name, files.file.type);
        console.log(tempFile, tempFile.size, "压缩后");
        _this.handle3(tempFile);
      });
    },
    afterRead4: function afterRead4(files, detail) {
      var _this = this;
      console.log(files.file.size, "压缩前");
      console.log("handle4");
      console.log(files.file);
      files.content = files.content.replace("data:application/octet-stream;", 'data:image/png;');
      this.filedata = 1;
      var base = files.content;

      var name = this.bumen.replace(/\//g, "") + files.file.name;
      console.log(name + "111filename");
      this.imageCompress(files.content, files.file.type).then(function (res) {
        files.content = res;

        var tempFile = _this.base64ToFile(res, name, files.file.type);
        console.log(tempFile, tempFile.size, "压缩后");
        _this.handle4(tempFile);
      });
    },
    afterRead5: function afterRead5(files, detail) {
      var _this = this;
      console.log(files.file.size, "压缩前");
      console.log("handle5");
      console.log(files.file);
      files.content = files.content.replace("data:application/octet-stream;", 'data:image/png;');
      this.filedata = 1;
      var base = files.content;
      var name = this.bumen.replace(/\//g, "") + files.file.name;

      this.imageCompress(files.content, files.file.type).then(function (res) {
        files.content = res;

        var tempFile = _this.base64ToFile(res, name, files.file.type);
        console.log(tempFile, tempFile.size, "压缩后");
        _this.handle5(tempFile);
      });
    },
    afterRead6: function afterRead6(files, detail) {
      var _this = this;
      console.log(files.file.size, "压缩前");
      console.log("handle6");
      console.log(files.file);
      files.content = files.content.replace("data:application/octet-stream;", 'data:image/png;');
      this.filedata = 1;
      var base = files.content;
      var name = this.bumen.replace(/\//g, "") + files.file.name;

      this.imageCompress(files.content, files.file.type).then(function (res) {
        files.content = res;

        var tempFile = _this.base64ToFile(res, name, files.file.type);
        console.log(tempFile, tempFile.size, "压缩后");
        _this.handle6(tempFile);
      });
    },
    afterRead7: function afterRead7(files, detail) {
      var _this = this;
      console.log(files.file.size, "压缩前");
      console.log("handle7");
      console.log(files.file);
      files.content = files.content.replace("data:application/octet-stream;", 'data:image/png;');
      this.filedata = 1;
      var base = files.content;
      var name = this.bumen.replace(/\//g, "") + files.file.name;

      this.imageCompress(files.content, files.file.type).then(function (res) {
        files.content = res;

        var tempFile = _this.base64ToFile(res, name, files.file.type);
        console.log(tempFile, tempFile.size, "压缩后");
        _this.handle7(tempFile);
      });
    },
    afterRead8: function afterRead8(files, detail) {
      var _this = this;
      console.log(files.file.size, "压缩前");
      console.log("handle8");
      console.log(files.file);
      files.content = files.content.replace("data:application/octet-stream;", 'data:image/png;');
      this.filedata = 1;
      var base = files.content;
      var name = this.bumen.replace(/\//g, "") + files.file.name;

      this.imageCompress(files.content, files.file.type).then(function (res) {
        files.content = res;

        var tempFile = _this.base64ToFile(res, name, files.file.type);
        console.log(tempFile, tempFile.size, "压缩后");
        _this.handle8(tempFile);
      });
    },
    compressImage: function compressImage(file) {

      var reader = new FileReader();
      reader.readAsDataURL(file);

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        reader.onload = function (e) {
          var img = new Image();
          img.src = e.target.result;
          img.onload = function () {

            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            var width = img.width,
                height = img.height;


            canvas.width = 100;
            canvas.height = 200;
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob(function (blob) {
              resolve(new File([blob], file.name, { type: "image/jpeg" }));
            }, "image/jpeg", 0.7);
          };
        };
      });
    },
    onDelete1: function onDelete1(file, detail) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("删除");
                _this5.filenames2.splice(detail.index, 1);

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    onDelete2: function onDelete2(file, detail) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("删除");
                _this6.filenames22.splice(detail.index, 1);

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    onDelete3: function onDelete3(file, detail) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log("删除");
                _this7.filenames222.splice(detail.index, 1);

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    },
    onDelete4: function onDelete4(file, detail) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log("删除");
                _this8.filenames2222.splice(detail.index, 1);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },
    onDelete5: function onDelete5(file, detail) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log("删除");
                _this9.filenames22222.splice(detail.index, 1);

              case 2:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    onDelete6: function onDelete6(file, detail) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                console.log("删除");
                _this10.filenames222222.splice(detail.index, 1);

              case 2:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this10);
      }))();
    },
    onDelete7: function onDelete7(file, detail) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                console.log("删除");
                _this11.filenames2222222.splice(detail.index, 1);

              case 2:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this11);
      }))();
    },
    onDelete8: function onDelete8(file, detail) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                console.log("删除");
                _this12.filenames22222222.splice(detail.index, 1);

              case 2:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this12);
      }))();
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'base64ToFile', function base64ToFile(base64Data, filename) {

    var arr = base64Data.split(",");
    var mime = arr[0].match(/:(.*?);/)[1];
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    var blob = new Blob([u8arr], { type: mime });

    var file = new File([blob], filename, { type: mime });

    return file;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'handle', function handle(file) {
    var _this13 = this;

    console.log("file是什么？");
    console.log(file);
    var formData = new FormData();
    formData.append("file", file);

    this.$axios({
      url: this.$httpUrl + "/common/upload",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      method: "post",
      data: formData
    }).then(function (res) {
      return res.data;
    }).then(function (res) {
      _this13.$set(_this13.paths, _this13.paths.length, res.path);
      if (res.code === 200) {
        console.log(222);
        console.log(res.fileName);
        _this13.filedata = 1;
        _this13.filenames2.push(res.fileName);
      } else {
        alert("上传失败，请重新打开相册选择该照片上传");
        alert(res);
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'handle2', function handle2(file) {
    var _this14 = this;

    console.log("file是什么？");
    console.log(file);
    var formData = new FormData();
    formData.append("file", file);

    this.$axios({
      url: this.$httpUrl + "/common/upload",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      method: "post",
      data: formData
    }).then(function (res) {
      return res.data;
    }).then(function (res) {
      console.log(res);
      console.log(res.path);
      _this14.$set(_this14.paths, _this14.paths.length, res.path);
      if (res.code === 200) {
        console.log(222);
        console.log(res.fileName);
        _this14.filedata = 1;
        _this14.filenames22.push(res.fileName);
      } else {
        alert("上传失败，请重新打开相册选择该照片上传");
        alert(res);
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'handle3', function handle3(file) {
    var _this15 = this;

    console.log("file是什么？");
    console.log(file);
    var formData = new FormData();
    formData.append("file", file);

    this.$axios({
      url: this.$httpUrl + "/common/upload",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      method: "post",
      data: formData
    }).then(function (res) {
      return res.data;
    }).then(function (res) {
      console.log(res);
      console.log(res.path);
      _this15.$set(_this15.paths, _this15.paths.length, res.path);
      if (res.code === 200) {
        console.log(222);
        console.log(res.fileName);
        _this15.filedata = 1;
        _this15.filenames222.push(res.fileName);
      } else {
        alert("上传失败，请重新打开相册选择该照片上传");
        alert(res);
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'handle4', function handle4(file) {
    var _this16 = this;

    console.log("file是什么？");
    console.log(file);
    var formData = new FormData();
    formData.append("file", file);

    this.$axios({
      url: this.$httpUrl + "/common/upload",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      method: "post",
      data: formData
    }).then(function (res) {
      return res.data;
    }).then(function (res) {
      console.log(res);
      console.log(res.path);
      _this16.$set(_this16.paths, _this16.paths.length, res.path);
      if (res.code === 200) {
        console.log(222);
        console.log(res.fileName);
        _this16.filedata = 1;
        _this16.filenames2222.push(res.fileName);
      } else {
        alert("上传失败，请重新打开相册选择该照片上传");
        alert(res);
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'handle5', function handle5(file) {
    var _this17 = this;

    console.log("file是什么？");
    console.log(file);
    var formData = new FormData();
    formData.append("file", file);

    this.$axios({
      url: this.$httpUrl + "/common/upload",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      method: "post",
      data: formData
    }).then(function (res) {
      return res.data;
    }).then(function (res) {
      console.log(res);
      console.log(res.path);
      _this17.$set(_this17.paths, _this17.paths.length, res.path);
      if (res.code === 200) {
        console.log(222);
        console.log(res.fileName);
        _this17.filedata = 1;
        _this17.filenames22222.push(res.fileName);
      } else {
        alert("上传失败，请重新打开相册选择该照片上传");
        alert(res);
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'handle6', function handle6(file) {
    var _this18 = this;

    console.log("file是什么？");
    console.log(file);
    var formData = new FormData();
    formData.append("file", file);

    this.$axios({
      url: this.$httpUrl + "/common/upload",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      method: "post",
      data: formData
    }).then(function (res) {
      return res.data;
    }).then(function (res) {
      console.log(res);
      console.log(res.path);
      _this18.$set(_this18.paths, _this18.paths.length, res.path);
      if (res.code === 200) {
        console.log(222);
        console.log(res.fileName);
        _this18.filedata = 1;
        _this18.filenames222222.push(res.fileName);
      } else {
        alert("上传失败，请重新打开相册选择该照片上传");
        alert(res);
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'handle7', function handle7(file) {
    var _this19 = this;

    console.log("file是什么？");
    console.log(file);
    var formData = new FormData();
    formData.append("file", file);

    this.$axios({
      url: this.$httpUrl + "/common/upload",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      method: "post",
      data: formData
    }).then(function (res) {
      return res.data;
    }).then(function (res) {
      console.log(res);
      console.log(res.path);
      _this19.$set(_this19.paths, _this19.paths.length, res.path);
      if (res.code === 200) {
        console.log(222);
        console.log(res.fileName);
        _this19.filedata = 1;
        _this19.filenames2222222.push(res.fileName);
      } else {
        alert("上传失败，请重新打开相册选择该照片上传");
        alert(res);
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'handle8', function handle8(file) {
    var _this20 = this;

    console.log("file是什么？");
    console.log(file);
    var formData = new FormData();
    formData.append("file", file);

    this.$axios({
      url: this.$httpUrl + "/common/upload",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      method: "post",
      data: formData
    }).then(function (res) {
      return res.data;
    }).then(function (res) {
      console.log(res);
      console.log(res.path);
      _this20.$set(_this20.paths, _this20.paths.length, res.path);
      if (res.code === 200) {
        console.log(222);
        console.log(res.fileName);
        _this20.filedata = 1;
        _this20.filenames22222222.push(res.fileName);
      } else {
        alert("上传失败，请重新打开相册选择该照片上传");
        alert(res);
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'gettime', function gettime() {
    console.log("im coming");
    var day = new Date();
    console.log(day);
    var seconds = day.getSeconds();
    if (seconds < 10) {

      seconds = "0" + seconds;
    } else {
      seconds = seconds;
    }
    var minutes = day.getMinutes();
    if (minutes < 10) {
      minutes = "0" + minutes;
    } else {
      minutes = minutes;
    }
    var month = day.getMonth();
    if (month < 10) {
      month = "0" + month;
    }
    var time = day.getFullYear() + "-" + (day.getMonth() + 1) + "-" + day.getDate() + " " + day.getHours() + ":" + minutes + ":" + seconds;
    return time;
  }), _methods)
});

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_tabbar_tabbar_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_tabbar_tabbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_components_tabbar_tabbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_icon_index_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_icon_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_icon_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_tabbar_tabbar_item_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_tabbar_tabbar_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_tabbar_tabbar_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_loading_index_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_view_box_index_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_view_box_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_view_box_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(45);










/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    headShow: function headShow() {
      return this.$store.getters.headShow;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    footerShow: function footerShow() {
      return this.$store.getters.footerShow;
    },
    pageTitle: function pageTitle() {
      return this.$store.getters.pageTitle;
    }
  },
  components: {
    Tabbar: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_tabbar_tabbar_vue___default.a,
    TabbarItem: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_tabbar_tabbar_item_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_header_index_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_loading_index_vue___default.a,
    ViewBox: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_view_box_index_vue___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_icon_index_vue___default.a
  },
  data: function data() {
    return {
      name: '',
      tel: '',
      taskname: '',
      totalData: [],
      uploader: [],
      uploader2: [],
      uploader3: [],
      uploader4: [],
      notes: '',
      value: '',
      value2: '',
      showPicker: '',
      columns: [],
      filenames2: [],
      filenames22: [],
      filenames222: [],
      filenames2222: [],
      paths: []
    };
  },
  mounted: function mounted() {
    this.$store.commit('UPDATE_PAGE_TITLE', '任务提交');
    this.showPicker = this.$route.params.titles;
    this.value2 = this.$route.params.id;
  },

  methods: {
    subConfirm: function subConfirm() {

      console.log(this.uploader[0]);

      var time = this.gettime();
      console.log(time);
      this.renwutijiao(time);
    },
    doPage: function doPage(wxid) {
      var _this = this;

      this.$axios.get(this.$httpUrl + '/daren/personwork/list?ryid=' + wxid + '&status=' + "未完成").then(function (res) {
        return res.data;
      }).then(function (res) {
        console.log(res);
        _this.totalData = res.rows;
        _this.totalData.forEach(function (item) {
          console.log(item.title);
          _this.$set(_this.columns, _this.columns.length, item.title);
        });
      });
    },
    renwutijiao: function renwutijiao(time) {
      var _this2 = this;

      this.$axios.post(this.$httpUrl + "/daren/external_personwork", {
        id: '',
        name: this.name,
        likedfile: this.filenames2.join(','),
        commentfile: this.filenames22.join(','),
        transmitfile: this.filenames222.join(','),
        watchingfile: this.filenames2222.join(','),
        phone: this.tel,
        workUnit: this.notes

      }).then(function (res) {
        return res.data;
      }).then(function (res) {
        console.log(res);

        if (res.code === 200) {
          _this2.$router.push('/shouye');
        } else {
          alert("提交失败");
        }
      });
    },
    afterRead: function afterRead(files, detail) {
      console.log("handle");
      console.log(files.file);
      files.content = files.content.replace('data:application/octet-stream;', 'data:image/png;');
      this.filedata = 1;
      var base = files.content;
      var name = files.name;
      console.log(base);
      console.log(name);
      this.handle(this.base64ToFile(base, name));
    },
    afterRead2: function afterRead2(files, detail) {
      console.log("handle2");
      console.log(files.file);
      files.content = files.content.replace('data:application/octet-stream;', 'data:image/png;');
      console.log(files.file);
      this.filedata = 1;
      var base = files.content;
      var name = files.name;
      console.log(base);
      console.log(name);
      this.handle2(this.base64ToFile(base, name));
    },
    afterRead3: function afterRead3(files, detail) {
      console.log("handle3");
      console.log(files.file);
      files.content = files.content.replace('data:application/octet-stream;', 'data:image/png;');
      console.log(files.content);
      this.filedata = 1;
      var base = files.content;
      var name = files.name;
      console.log(base);
      console.log(name);

      this.handle3(this.base64ToFile(base, name));
    },
    afterRead4: function afterRead4(files, detail) {
      console.log("handle4");
      console.log(files.file);
      files.content = files.content.replace('data:application/octet-stream;', 'data:image/png;');
      this.filedata = 1;
      var base = files.content;
      var name = files.name;
      console.log(base);
      console.log(name);

      this.handle4(this.base64ToFile(base, name));
    },
    base64ToFile: function base64ToFile(base64Data, filename) {

      var arr = base64Data.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      var blob = new Blob([u8arr], { type: mime });

      var file = new File([blob], filename, { type: mime });

      return file;
    },
    handle: function handle(file) {
      var _this3 = this;

      var formData = new FormData();
      formData.append("file", file);

      this.$axios({
        url: this.$httpUrl + "/common/upload",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        method: "post",
        data: formData
      }).then(function (res) {
        return res.data;
      }).then(function (res) {
        console.log(res);
        console.log(res.path);
        _this3.$set(_this3.paths, _this3.paths.length, res.path);
        if (res.code === 200) {
          console.log(222);
          console.log(res.fileName);
          _this3.filenames2.push(res.fileName);
        } else {}
      });
    },
    handle2: function handle2(file) {
      var _this4 = this;

      var formData = new FormData();
      formData.append("file", file);

      this.$axios({
        url: this.$httpUrl + "/common/upload",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        method: "post",
        data: formData
      }).then(function (res) {
        return res.data;
      }).then(function (res) {
        console.log(res);
        console.log(res.path);
        _this4.$set(_this4.paths, _this4.paths.length, res.path);
        if (res.code === 200) {
          console.log(222);
          console.log(res.fileName);
          _this4.filenames22.push(res.fileName);
        } else {}
      });
    },
    handle3: function handle3(file) {
      var _this5 = this;

      var formData = new FormData();
      formData.append("file", file);

      this.$axios({
        url: this.$httpUrl + "/common/upload",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        method: "post",
        data: formData
      }).then(function (res) {
        return res.data;
      }).then(function (res) {
        console.log(res);
        console.log(res.path);
        _this5.$set(_this5.paths, _this5.paths.length, res.path);
        if (res.code === 200) {
          console.log(222);
          console.log(res.fileName);
          _this5.filenames222.push(res.fileName);
        } else {}
      });
    },
    handle4: function handle4(file) {
      var _this6 = this;

      var formData = new FormData();
      formData.append("file", file);

      this.$axios({
        url: this.$httpUrl + "/common/upload",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        method: "post",
        data: formData
      }).then(function (res) {
        return res.data;
      }).then(function (res) {
        console.log(res);
        console.log(res.path);
        _this6.$set(_this6.paths, _this6.paths.length, res.path);
        if (res.code === 200) {
          console.log(222);
          console.log(res.fileName);
          _this6.filenames2222.push(res.fileName);
        } else {}
      });
    },
    gettime: function gettime() {
      console.log("im coming");
      var day = new Date();
      console.log(day);
      var seconds = day.getSeconds();
      if (seconds < 10) {
        seconds = "0" + seconds;
      } else {
        seconds = seconds;
      }
      var minutes = day.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      } else {
        minutes = minutes;
      }
      var month = day.getMonth();
      if (month < 10) {
        month = "0" + month;
      }
      var time = day.getFullYear() + "-" + (day.getMonth() + 1) + "-" + day.getDate() + " " + day.getHours() + ":" + minutes + ":" + seconds;
      return time;
    }
  }
});

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_tabbar_tabbar_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_tabbar_tabbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_tabbar_tabbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_icon_index_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_icon_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_icon_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_tabbar_tabbar_item_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_tabbar_tabbar_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_tabbar_tabbar_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_header_index_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_loading_index_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_view_box_index_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_view_box_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_view_box_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(45);












/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    headShow: function headShow() {
      return this.$store.getters.headShow;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    footerShow: function footerShow() {
      return this.$store.getters.footerShow;
    },
    pageTitle: function pageTitle() {
      return "资料完善";
    }
  },
  components: {
    Tabbar: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_tabbar_tabbar_vue___default.a,
    TabbarItem: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_tabbar_tabbar_item_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_x_header_index_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_loading_index_vue___default.a,
    ViewBox: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_view_box_index_vue___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_icon_index_vue___default.a
  },
  data: function data() {
    var _ref;

    return _ref = {

      selectedIndex: [0, 0],

      columns: [this.provinces, []],

      taskname: '',
      name: '',
      tel: '',
      wxid: '',
      totalData: [],
      uploader: [],
      notes: '',
      value: '',
      value2: '',
      showPicker: false
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'columns', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'isPhoneValid', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'paths', []), _ref;
  },
  mounted: function mounted() {

    this.$store.commit('UPDATE_PAGE_TITLE', '任务提交');
    this.list = this.initList;

    this.doPage();
  },

  methods: {
    onConfirm: function onConfirm(value) {
      this.value = value.filter(function (item) {
        return !!item;
      }).join('/');
      this.showPicker = false;
    },
    subConfirm: function subConfirm() {
      console.log("进来了");
      console.log(this.value);

      var regex = /^1(3|4|5|6|7|8|9)\d{9}$/;
      this.isPhoneValid = regex.test(this.tel);

      if (this.isPhoneValid) {
        console.log(this.tel.length);
        if (this.value === '' || this.name === '') {

          this.$message({
            message: '字段不允许为空',
            type: 'error'
          });
        } else {
          this.xinxitijiao();
        }
      } else {
        this.$message({
          message: '手机号错误，请填写11位正确手机号',
          type: 'error'
        });
      }
    },
    assembleTree: function assembleTree(nodes) {
      var tree = [];
      var nodeMap = {};

      nodes.forEach(function (node) {
        if (node.parentId === 100) {
          if (node.deptName !== '交警大队') {
            node.children = [{ deptName: '' }];
          }
        }
        nodeMap[node.deptId] = node;
      });

      nodes.forEach(function (node) {
        if (node.parentId === 0) {
          tree.push(node);
        } else {
          var parentNode = nodeMap[node.parentId];
          if (!parentNode.children) {
            parentNode.children = [];
          }
          parentNode.children.push(node);
        }
      });

      return tree;
    },
    doPage: function doPage() {
      var _this = this;

      this.$axios.get(this.$httpUrl + '/system/dept/list').then(function (res) {
        return res.data;
      }).then(function (res) {
        console.log(res);

        var tree = _this.assembleTree(res.data);
        _this.columns = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(tree[0]['children']));
      });
    },
    bumen: function bumen() {
      this.$axios.get(this.$httpUrl + '/system/dept/list').then(function (res) {
        return res.data;
      }).then(function (res) {
        console.log(res);
      });
    },
    xinxitijiao: function xinxitijiao() {
      var _this2 = this;

      this.$axios.post(this.$httpUrl + "/daren/darennewuser", {
        wxid: localStorage.getItem("wxid"),

        tel: this.tel,
        name: this.name,
        unit: '/' + this.value

      }).then(function (res) {
        return res.data;
      }).then(function (res) {
        console.log(res);
        console.log(res.code);
        console.log(res.msg);
        if (res.code === "200") {
          alert("新增成功，跳转到登录页");
          _this2.$router.push('/login');
        } else if (res.code === "300") {
          alert("重复增加");
          _this2.$router.push('/login');
        } else {
          alert("插入失败，请重新填写信息");
        }
      });
    },
    renwutijiao: function renwutijiao() {
      var _this3 = this;

      this.$axios.post(this.$httpUrl + "/daren/personwork", {
        id: this.value2,
        message: this.notes,
        wcfile: this.paths[0]

      }).then(function (res) {
        return res.data;
      }).then(function (res) {
        console.log(res);
        if (res.code === 200) {
          _this3.$router.push('/memberHome/dashbord');
        }
      });
    },
    afterRead: function afterRead(files, detail) {

      console.log(files.file);
      this.handle(files.file);
    },
    handle: function handle(file) {
      var _this4 = this;

      var formData = new FormData();
      formData.append("file", file);

      this.$axios({
        url: this.$httpUrl + "/common/upload2",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        method: "post",
        data: formData
      }).then(function (res) {
        return res.data;
      }).then(function (res) {
        console.log(res);
        console.log(res.path);
        _this4.$set(_this4.paths, _this4.paths.length, res.path);
        if (res.code === 200) {
          console.log(222);
          console.log(res.path);
        } else {}
      });
    }
  }
});

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant__ = __webpack_require__(85);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      msg1: true,
      msg2: false,
      infoShow: true,
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }, { min: 6, max: 12, message: '密码长度在 6 到 12 个字符', trigger: 'blur' }]
      }
    };
  },

  methods: {
    submitForm: function submitForm(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {

          _this2.$axios.post(_this2.$httpUrl + "/daren/darennewuser/login", {
            wxid: _this2.loginForm.username

          }).then(function (res) {
            return res.data;
          }).then(function (res) {
            console.log(res);
            if (res.code == 200) {
              localStorage.setItem("wxid", _this2.loginForm.username);

              _this2.$router.push('/memberHome/dashbord');
            } else if (res.code == 300) {
              localStorage.setItem("wxid", _this2.loginForm.username);
              _this2.msg1 = false;
              _this2.msg2 = true;
              _this2.$message({
                message: '后台管理员未审核请等待审核！',
                type: 'success'
              });
            } else if (res.code == 350) {
              localStorage.setItem("wxid", _this2.loginForm.username);
              _this2.$message({
                message: '第一次注册，请完善资料后等待审核！',
                type: 'success'
              });

              _this2.$router.push('/Tupload');
            } else {

              alert("校验失败，用户名或密码错误！");
              return false;
            }
          });
        }
      });
    },
    getcode: function getcode(code) {
      var _this3 = this;

      this.$axios.get(this.$httpUrl + '/daren/darennewuser/getopenid?code=' + code).then(function (res) {
        return res.data;
      }).then(function (res) {
        console.log(res);

        localStorage.setItem("wxid", res.openid);
        _this3.loginForm.username = res.openid;
        console.log(res.openid);
        _this3.submitForm('loginForm');
      });
    },
    getCode2: function getCode2() {
      var code = this.getUrlCode('code');
      var local = window.location.href;
      var appid = "wx42c6d3b85f7597bb";
      if (code == null || code === '') {
        console.log("进入微信跳转");
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx42c6d3b85f7597bb&redirect_uri=http://www.qlslj.cn&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
      } else {
        this.getcode(code);
      }
    },
    getOpenId: function getOpenId(code) {
      var _this = this;
      this.$http.post('/api/user/wechat/login', { code: code }).then(function (res) {
        var datas = res.data;
        if (datas.code === 0) {
          console.log('成功');
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getUrlCode: function getUrlCode(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");

      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      } else {
        return null;
      }
    }
  },
  created: function created() {
    console.log("预加载");
    this.getCode2();
  }
});

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_tabbar_tabbar_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_tabbar_tabbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_tabbar_tabbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_icon_index_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_icon_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_icon_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_tabbar_tabbar_item_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_tabbar_tabbar_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_tabbar_tabbar_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_loading_index_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_loading_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_view_box_index_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_view_box_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_view_box_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(45);


var _computed$components$;










/* harmony default export */ __webpack_exports__["default"] = (_computed$components$ = {
  computed: {
    headShow: function headShow() {
      return this.$store.getters.headShow;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    footerShow: function footerShow() {
      return this.$store.getters.footerShow;
    },
    pageTitle: function pageTitle() {
      return "个人积分";
    }
  },
  components: {
    Tabbar: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_tabbar_tabbar_vue___default.a,
    TabbarItem: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_tabbar_tabbar_item_vue___default.a,
    XHeader: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_x_header_index_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_loading_index_vue___default.a,
    ViewBox: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_view_box_index_vue___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_icon_index_vue___default.a
  },
  data: function data() {
    return {
      myIndex: 111,
      mingci: 1000,
      jifen: 100,
      name: "无权限",
      icOne: __webpack_require__(427),
      icTwo: __webpack_require__(429),
      icThree: __webpack_require__(428),
      show: false,
      datas: []
    };
  },
  mounted: function mounted() {
    this.$store.commit("UPDATE_PAGE_TITLE", "任务提交");
    this.showPicker = this.$route.params.titles;
    this.value2 = this.$route.params.id;
  },
  created: function created() {
    console.log("预加载");
    this.getall();

    this.getCode2();
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_computed$components$, 'computed', {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_computed$components$, 'methods', {
  getcode: function getcode(code) {
    var _this = this;

    this.$axios.get(this.$httpUrl + "/daren/darennewuser/getopenid?code=" + code).then(function (res) {
      return res.data;
    }).then(function (res) {
      console.log(res);

      localStorage.setItem("wxid", res.openid);

      console.log(res.openid);

      _this.getgrbywxid(res.openid);
    });
  },
  getCode2: function getCode2() {

    var code = this.getUrlCode("code");
    var local = window.location.href;
    var appid = "wx42c6d3b85f7597bb";
    if (code == null || code === "") {
      console.log("进入微信跳转");
      window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx42c6d3b85f7597bb&redirect_uri=http://www.qlslj.cn/studyRanking&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
    } else {
      this.getcode(code);
    }
  },
  getUrlCode: function getUrlCode(name) {

    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");

    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
      return unescape(r[2]);
    } else {
      return null;
    }
  },
  getall: function getall() {
    var _this2 = this;

    this.$axios.get(this.$httpUrl + "/daren/point/list?pageSize=1000&pageNum=1").then(function (res) {
      return res.data;
    }).then(function (res) {
      console.log(res);
      _this2.datas = res.rows;
    });
  },
  getgrbywxid: function getgrbywxid(wxid) {
    var _this3 = this;

    this.$axios.get(this.$httpUrl + "/daren/point/queryByWxid?wxid=" + wxid).then(function (res) {
      return res.data;
    }).then(function (res) {
      console.log(res);

      if (res.result != "ok") {

        _this3.show = true;
      } else {

        console.log(res.user_info);
        console.log(res.user_info.name);

        _this3.name = res.user_info.name;

        _this3.jifen = res.user_info.point;

        _this3.mingci = res.rank;
      }
    });
  },
  getImg: function getImg(index) {
    if (index == 0) {
      return this.icOne;
    } else if (index == 1) {
      return this.icTwo;
    } else if (index == 2) {
      return this.icThree;
    }
  },
  getphone: function getphone(number) {
    var masked = number.replace(/(\d{3})\d{4}(\d{3})/, '$1****$2');
    return masked;
  }
}), _computed$components$);

/***/ }),

/***/ 393:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 394:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 395:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 397:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 398:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 399:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 401:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 402:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 405:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 406:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 407:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 410:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 411:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 412:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ceshi.38bb77c.png";

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ic_one.cf5f756.png";

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ic_three.9bbf911.png";

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ic_two.913d459.png";

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jifen.559c813.png";

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(542),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(401)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(532),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(402)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(533),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),

/***/ 524:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "vux-demo-header-box",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('x-header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headShow),
      expression: "headShow"
    }],
    attrs: {
      "left-options": {
        backText: ''
      }
    }
  }, [_vm._v(_vm._s(_vm.pageTitle))])], 1), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "姓名",
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "电话",
      "placeholder": "电话"
    },
    model: {
      value: (_vm.tel),
      callback: function($$v) {
        _vm.tel = $$v
      },
      expression: "tel"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "uploader",
      "label": "点赞截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead
          },
          model: {
            value: (_vm.uploader),
            callback: function($$v) {
              _vm.uploader = $$v
            },
            expression: "uploader"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "uploader2",
      "label": "评论截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead2
          },
          model: {
            value: (_vm.uploader2),
            callback: function($$v) {
              _vm.uploader2 = $$v
            },
            expression: "uploader2"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "uploader3",
      "label": "转发截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead3
          },
          model: {
            value: (_vm.uploader3),
            callback: function($$v) {
              _vm.uploader3 = $$v
            },
            expression: "uploader3"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "uploader4",
      "label": "再看截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead4
          },
          model: {
            value: (_vm.uploader4),
            callback: function($$v) {
              _vm.uploader4 = $$v
            },
            expression: "uploader4"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rows": "2",
      "autosize": "",
      "label": "备注信息",
      "type": "textarea",
      "maxlength": "50",
      "placeholder": "备注信息",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.notes),
      callback: function($$v) {
        _vm.notes = $$v
      },
      expression: "notes"
    }
  })], 1), _vm._v(" "), _c('van-button', {
    staticClass: "tijiao",
    attrs: {
      "round": "",
      "type": "info",
      "size": "large"
    },
    on: {
      "click": _vm.subConfirm
    }
  }, [_vm._v("提交")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 525:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-tab"
  }, [_vm._t("header"), _vm._v(" "), _c('div', {
    ref: "viewBoxBody",
    staticClass: "weui-tab__panel vux-fix-safari-overflow-scrolling",
    style: ({
      paddingTop: _vm.bodyPaddingTop,
      paddingBottom: _vm.bodyPaddingBottom
    }),
    attrs: {
      "id": "vux_view_box_body"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("bottom")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 526:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: ['vux-badge', {
      'vux-badge-dot': typeof _vm.text === 'undefined',
      'vux-badge-single': typeof _vm.text !== 'undefined' && _vm.text.toString().length === 1
    }],
    domProps: {
      "textContent": _vm._s(_vm.text)
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 527:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.rules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "微信id:",
      "prop": "username"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.loginForm.username),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "username", $$v)
      },
      expression: "loginForm.username"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "60%",
      "font-weight": "bold"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('loginForm')
      }
    }
  }, [_vm._v("登 录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "90%",
      "font-size": "15px"
    }
  }, [_vm._v("\n      备案/许可证编号为:蜀ICP备2020029625号-8\n    ")]), _vm._v(" "), _c('van-dialog', {
    staticStyle: {
      "width": "110%",
      "height": "1200px"
    },
    attrs: {
      "show-confirm-button": false,
      "title": ""
    },
    model: {
      value: (_vm.infoShow),
      callback: function($$v) {
        _vm.infoShow = $$v
      },
      expression: "infoShow"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "500px"
    }
  }, [(this.msg1) ? _c('van-loading', {
    attrs: {
      "type": "spinner",
      "size": "80px",
      "color": "#1989fa"
    }
  }) : _vm._e(), _vm._v(" "), (this.msg2) ? _c('van-loading', {
    attrs: {
      "type": "spinner",
      "size": "80px",
      "color": "#1989fa"
    }
  }, [_vm._v("后台管理员未审核请等待审核！ ")]) : _vm._e()], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('h2', [_vm._v("崃警网宣系统")])])
}]}

/***/ }),

/***/ 528:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-x-dialog",
    class: {
      'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-mask",
    style: (_vm.maskStyle),
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.hide.apply(null, arguments)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: _vm.dialogClass,
    style: (_vm.dialogStyle)
  }, [_vm._t("default")], 2)])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 529:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-loading_toast vux-loading",
    class: !_vm.text ? 'vux-loading-no-text' : ''
  }, [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-toast",
    style: ({
      position: _vm.position
    })
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v(_vm._s(_vm.text || '加载中')), _vm._t("default")], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 530:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: [_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']
  })
},staticRenderFns: []}

/***/ }),

/***/ 531:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "vux-demo-header-box",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('x-header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headShow),
      expression: "headShow"
    }],
    attrs: {
      "left-options": {
        backText: ''
      }
    }
  }, [_vm._v(_vm._s(_vm.pageTitle))])], 1), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "任务名称",
      "placeholder": "任务名称",
      "readonly": ""
    },
    model: {
      value: (_vm.showPicker),
      callback: function($$v) {
        _vm.showPicker = $$v
      },
      expression: "showPicker"
    }
  }), _vm._v(" "), (_vm.containsChar3) ? _c('van-field', {
    attrs: {
      "required": "",
      "name": "uploader3",
      "label": "转发截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead3,
            "max-count": 10,
            "before-delete": _vm.onDelete3
          },
          model: {
            value: (_vm.uploader3),
            callback: function($$v) {
              _vm.uploader3 = $$v
            },
            expression: "uploader3"
          }
        })]
      },
      proxy: true
    }], null, false, 1265252122)
  }) : _vm._e(), _vm._v(" "), (_vm.containsChar4) ? _c('van-field', {
    attrs: {
      "required": "",
      "name": "uploader4",
      "label": "在看截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead4,
            "max-count": 10,
            "before-delete": _vm.onDelete4
          },
          model: {
            value: (_vm.uploader4),
            callback: function($$v) {
              _vm.uploader4 = $$v
            },
            expression: "uploader4"
          }
        })]
      },
      proxy: true
    }], null, false, 1797183421)
  }) : _vm._e(), _vm._v(" "), (_vm.containsChar1) ? _c('van-field', {
    attrs: {
      "required": "",
      "name": "uploader",
      "label": "点赞截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead,
            "max-count": 10,
            "before-delete": _vm.onDelete1
          },
          model: {
            value: (_vm.uploader),
            callback: function($$v) {
              _vm.uploader = $$v
            },
            expression: "uploader"
          }
        })]
      },
      proxy: true
    }], null, false, 308691352)
  }) : _vm._e(), _vm._v(" "), (_vm.containsChar2) ? _c('van-field', {
    attrs: {
      "required": "",
      "name": "uploader2",
      "label": "评论截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead2,
            "max-count": 10,
            "before-delete": _vm.onDelete2
          },
          model: {
            value: (_vm.uploader2),
            callback: function($$v) {
              _vm.uploader2 = $$v
            },
            expression: "uploader2"
          }
        })]
      },
      proxy: true
    }], null, false, 85007355)
  }) : _vm._e(), _vm._v(" "), (_vm.containsChar5) ? _c('van-field', {
    attrs: {
      "required": "",
      "name": "uploader5",
      "label": "举报截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead5,
            "max-count": 10,
            "before-delete": _vm.onDelete5
          },
          model: {
            value: (_vm.uploader5),
            callback: function($$v) {
              _vm.uploader5 = $$v
            },
            expression: "uploader5"
          }
        })]
      },
      proxy: true
    }], null, false, 1897404636)
  }) : _vm._e(), _vm._v(" "), (_vm.containsChar6) ? _c('van-field', {
    attrs: {
      "required": "",
      "name": "uploader6",
      "label": "关注截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead6,
            "max-count": 10,
            "before-delete": _vm.onDelete6
          },
          model: {
            value: (_vm.uploader6),
            callback: function($$v) {
              _vm.uploader6 = $$v
            },
            expression: "uploader6"
          }
        })]
      },
      proxy: true
    }], null, false, 773669759)
  }) : _vm._e(), _vm._v(" "), (_vm.containsChar7) ? _c('van-field', {
    attrs: {
      "required": "",
      "name": "uploader7",
      "label": "投票截图1"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead7,
            "max-count": 10,
            "before-delete": _vm.onDelete7
          },
          model: {
            value: (_vm.uploader7),
            callback: function($$v) {
              _vm.uploader7 = $$v
            },
            expression: "uploader7"
          }
        })]
      },
      proxy: true
    }], null, false, 1953914526)
  }) : _vm._e(), _vm._v(" "), (_vm.containsChar8) ? _c('van-field', {
    attrs: {
      "required": "",
      "name": "uploader8",
      "label": "投票截图2"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead8,
            "max-count": 10,
            "before-delete": _vm.onDelete8
          },
          model: {
            value: (_vm.uploader8),
            callback: function($$v) {
              _vm.uploader8 = $$v
            },
            expression: "uploader8"
          }
        })]
      },
      proxy: true
    }], null, false, 2321755953)
  }) : _vm._e(), _vm._v(" "), _c('van-field', {
    attrs: {
      "rows": "2",
      "autosize": "",
      "label": "备注信息",
      "type": "textarea",
      "maxlength": "50",
      "placeholder": "备注信息",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.notes),
      callback: function($$v) {
        _vm.notes = $$v
      },
      expression: "notes"
    }
  })], 1), _vm._v(" "), _c('van-button', {
    staticClass: "tijiao",
    attrs: {
      "round": "",
      "type": "info",
      "size": "large"
    },
    on: {
      "click": _vm.subConfirm
    }
  }, [_vm._v("提交")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 532:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-tabbar"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 533:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-header"
  }, [_c('div', {
    staticClass: "vux-header-left"
  }, [_vm._t("overwrite-left", function() {
    return [_c('transition', {
      attrs: {
        "name": _vm.transition
      }
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm._leftOptions.showBack),
        expression: "_leftOptions.showBack"
      }],
      staticClass: "vux-header-back",
      on: {
        "click": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "preventDefault", undefined, $event.key, undefined)) { return null; }
        }, _vm.onClickBack]
      }
    }, [_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": _vm.transition
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm._leftOptions.showBack),
        expression: "_leftOptions.showBack"
      }],
      staticClass: "left-arrow",
      on: {
        "click": _vm.onClickBack
      }
    })])]
  }), _vm._v(" "), _vm._t("left")], 2), _vm._v(" "), (!_vm.shouldOverWriteTitle) ? _c('h1', {
    staticClass: "vux-header-title",
    on: {
      "click": function($event) {
        return _vm.$emit('on-click-title')
      }
    }
  }, [_vm._t("default", function() {
    return [_c('transition', {
      attrs: {
        "name": _vm.transition
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.title),
        expression: "title"
      }]
    }, [_vm._v(_vm._s(_vm.title))])])]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.shouldOverWriteTitle) ? _c('div', {
    staticClass: "vux-header-title-area"
  }, [_vm._t("overwrite-title")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vux-header-right"
  }, [(_vm.rightOptions.showMore) ? _c('a', {
    staticClass: "vux-header-more",
    on: {
      "click": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "preventDefault", undefined, $event.key, undefined)) { return null; }
      }, function($event) {
        return _vm.$emit('on-click-more')
      }]
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("right")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "vux-demo-header-box",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('x-header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headShow),
      expression: "headShow"
    }],
    attrs: {
      "left-options": {
        backText: ''
      }
    }
  }, [_vm._v(_vm._s(_vm.pageTitle))])], 1), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    staticStyle: {
      "width": "100%",
      "height": "70px",
      "font-size": "18px",
      "padding": "20px"
    },
    attrs: {
      "readonly": "",
      "clickable": "",
      "size": "large",
      "label": "请选择单位",
      "value": _vm.value,
      "placeholder": "选择单位",
      "required": ""
    },
    on: {
      "click": function($event) {
        _vm.showPicker = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showPicker),
      callback: function($$v) {
        _vm.showPicker = $$v
      },
      expression: "showPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "value-key": "deptName",
      "columns": _vm.columns
    },
    on: {
      "cancel": function($event) {
        _vm.showPicker = false
      },
      "confirm": _vm.onConfirm
    }
  })], 1), _vm._v(" "), _c('van-field', {
    staticStyle: {
      "width": "100%",
      "height": "70px",
      "font-size": "18px",
      "padding": "20px"
    },
    attrs: {
      "required": "",
      "size": "large",
      "label": "姓名",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('van-field', {
    staticStyle: {
      "width": "100%",
      "height": "70px",
      "font-size": "18px",
      "padding": "20px"
    },
    attrs: {
      "name": "tel",
      "required": "",
      "size": "large",
      "label": "电话",
      "placeholder": "请输入电话"
    },
    model: {
      value: (_vm.tel),
      callback: function($$v) {
        _vm.tel = $$v
      },
      expression: "tel"
    }
  })], 1), _vm._v(" "), _c('van-button', {
    staticClass: "tijiao",
    attrs: {
      "round": "",
      "type": "info",
      "size": "large"
    },
    on: {
      "click": _vm.subConfirm
    }
  }, [_vm._v("提交")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "weui-btn",
    class: _vm.classes,
    style: (_vm.buttonStyle),
    attrs: {
      "disabled": _vm.disabled,
      "type": _vm.actionType
    },
    on: {
      "click": _vm.onClick
    }
  }, [(_vm.showLoading) ? _c('i', {
    staticClass: "weui-loading"
  }) : _vm._e(), _vm._v(" "), _vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.text))]
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-alert"
  }, [_c('x-dialog', {
    attrs: {
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.dialogTransition,
      "hide-on-blur": _vm.hideOnBlur,
      "mask-z-index": _vm.maskZIndex
    },
    on: {
      "on-hide": function($event) {
        return _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        return _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._t("default", function() {
    return [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.content)
      }
    })]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onHide
    }
  }, [_vm._v(_vm._s(_vm.buttonText || '确定'))])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 537:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    staticClass: "vux-x-img",
    attrs: {
      "src": _vm.defaultSrc,
      "data-src": _vm.currentSrc
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-image', {
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "radius": "10px",
      "fit": "contain",
      "src": __webpack_require__(430)
    }
  }), _vm._v(" "), _c('van-popup', {
    staticStyle: {
      "width": "70%",
      "height": "100px",
      "align-content": "center",
      "text-align": "center",
      "font-size": "large"
    },
    attrs: {
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_vm._v("抱歉，你没有权限查看")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box1"
  }, [_vm._v("全局排名第 " + _vm._s(_vm.mingci))]), _vm._v(" "), _c('div', {
    staticClass: "box2"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "box3"
  }, [_vm._v(_vm._s(_vm.jifen) + " 积分")])]), _vm._v(" "), _c('div', {
    staticClass: "top-wrap"
  }, _vm._l((_vm.datas), function(item, index) {
    return _c('div', {
      key: item.index,
      staticClass: "list-item"
    }, [(index == 0) ? _c('div', {
      staticClass: "line"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [(index <= 2) ? _c('van-image', {
      staticClass: "img-tag",
      attrs: {
        "width": "30",
        "src": _vm.getImg(index)
      }
    }) : _vm._e(), _vm._v(" "), (index > 2) ? _c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(index + 1))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "20px",
        "width": "60px"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "15px",
        "width": "100px"
      }
    }, [_vm._v(_vm._s(_vm.getphone(item.phone)))]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.point) + " 积分 ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "line"
    })])
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "memberHome",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewbox"
  }, [_c('router-view'), _vm._v(" "), _c('tabbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.footerShow),
      expression: "footerShow"
    }]
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tupian"
  }, [_c('van-image', {
    attrs: {
      "width": "auto",
      "height": "200",
      "src": __webpack_require__(426)
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "vux-demo-header-box",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('x-header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headShow),
      expression: "headShow"
    }],
    attrs: {
      "left-options": {
        backText: ''
      }
    }
  }, [_vm._v(_vm._s(_vm.pageTitle))])], 1), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('van-search', {
    attrs: {
      "placeholder": "请输入搜索关键词"
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._l((_vm.paginatedData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zx-task-box",
      on: {
        "click": function($event) {
          return _vm.listDes(item)
        }
      }
    }, [_c('div', {
      staticClass: "zx-task-box-title"
    }, [_c('div', {
      staticStyle: {
        "margin-left": "5px"
      }
    }, [(item.demand.includes('点赞')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "success"
      }
    }, [_vm._v(" 点赞  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('转发')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_vm._v(" 转发  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('在看')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "success",
        "color": "blue"
      }
    }, [_vm._v(" 在看  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('评论')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "warning",
        "color": "grey"
      }
    }, [_vm._v(" 评论  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('举报')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "danger",
        "color": "red"
      }
    }, [_vm._v(" 举报  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('关注')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "danger",
        "color": "red"
      }
    }, [_vm._v(" 关注  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('投票')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "danger",
        "color": "red"
      }
    }, [_vm._v(" 投票  ")])], 1) : _vm._e()]), _vm._v(" "), _c('br')]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "zx-task-box-des"
    }, [_vm._v("\n            任务名称："), _c('div', {
      staticStyle: {
        "color": "grey",
        "margin-bottom": "1px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" \n            结束时间："), _c('div', {
      staticStyle: {
        "color": "grey",
        "margin-bottom": "10px"
      }
    }, [_vm._v(" " + _vm._s(item.endtime))])])])
  }), _vm._v(" "), _c('van-pagination', {
    attrs: {
      "page-count": _vm.pageCount
    },
    on: {
      "change": _vm.handlePageChange
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 2), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "任务详情"
    },
    model: {
      value: (_vm.infoShow),
      callback: function($$v) {
        _vm.infoShow = $$v
      },
      expression: "infoShow"
    }
  }, [_c('van-cell-group', {
    staticClass: "asd",
    style: (_vm.test)
  }, [_c('div', {
    staticStyle: {
      "margin-left": "5px"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "size": "large",
      "label-class": "label",
      "label": "任务名称:",
      "value": _vm.tanchukuang.title,
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "size": "large",
      "label": "开始时间:",
      "value": _vm.tanchukuang.starttime,
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "size": "large",
      "label": "结束时间:",
      "value": _vm.tanchukuang.endtime,
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "size": "large",
      "label": "任务需求:",
      "value": _vm.tanchukuang.demand,
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "size": "large",
      "label": "备注信息:",
      "value": _vm.tanchukuang.message,
      "readonly": ""
    }
  }), _vm._v(" "), _c('div', _vm._l((_vm.urls), function(item, index) {
    return _c('van-field', {
      key: index,
      attrs: {
        "error": "",
        "size": "large",
        "label": "点击跳转:",
        "value": item,
        "readonly": ""
      },
      on: {
        "click": function($event) {
          return _vm.open(item)
        }
      }
    })
  }), 1), _vm._v(" "), (_vm.dianzan(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "点赞示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist),
            callback: function($$v) {
              _vm.filelist = $$v
            },
            expression: "filelist"
          }
        })]
      },
      proxy: true
    }], null, false, 2136404113)
  }) : _vm._e(), _vm._v(" "), (_vm.zaikan(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "在看示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist1),
            callback: function($$v) {
              _vm.filelist1 = $$v
            },
            expression: "filelist1"
          }
        })]
      },
      proxy: true
    }], null, false, 2313403904)
  }) : _vm._e(), _vm._v(" "), (_vm.zhuangfa(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "转发示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist2),
            callback: function($$v) {
              _vm.filelist2 = $$v
            },
            expression: "filelist2"
          }
        })]
      },
      proxy: true
    }], null, false, 4142773635)
  }) : _vm._e(), _vm._v(" "), (_vm.pinglun(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "评论示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist3),
            callback: function($$v) {
              _vm.filelist3 = $$v
            },
            expression: "filelist3"
          }
        })]
      },
      proxy: true
    }], null, false, 393317890)
  }) : _vm._e(), _vm._v(" "), (_vm.jubao(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "举报示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist4),
            callback: function($$v) {
              _vm.filelist4 = $$v
            },
            expression: "filelist4"
          }
        })]
      },
      proxy: true
    }], null, false, 593878405)
  }) : _vm._e(), _vm._v(" "), (_vm.guanzhu(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "关注示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist5),
            callback: function($$v) {
              _vm.filelist5 = $$v
            },
            expression: "filelist5"
          }
        })]
      },
      proxy: true
    }], null, false, 2974227716)
  }) : _vm._e(), _vm._v(" "), (_vm.toupiao(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "投票示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist6),
            callback: function($$v) {
              _vm.filelist6 = $$v
            },
            expression: "filelist6"
          }
        })]
      },
      proxy: true
    }], null, false, 508630151)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('van-button', {
    staticStyle: {
      "width": "100px",
      "height": "40px",
      "margin-top": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.tiao(_vm.tanchukuang.title, _vm.tanchukuang.id, _vm.tanchukuang.demand, _vm.tanchukuang.bumen, _vm.urls)
      }
    }
  }, [_vm._v("提交任务")])], 1)], 1)], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "完成情况"
    },
    model: {
      value: (_vm.infoShow1),
      callback: function($$v) {
        _vm.infoShow1 = $$v
      },
      expression: "infoShow1"
    }
  }, [_c('van-cell-group', {
    staticClass: "asd",
    style: (_vm.test)
  }, [_c('van-field', {
    attrs: {
      "size": "large",
      "label-class": "label",
      "label": "任务名称:",
      "value": _vm.tanchukuang.title,
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "size": "large",
      "label": "任务需求:",
      "value": _vm.tanchukuang.demand,
      "readonly": ""
    }
  }), _vm._v(" "), (this.sfxs === 2) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "退回原因:",
      "value": _vm.tanchukuang.message,
      "readonly": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.urls), function(item, index) {
    return _c('van-field', {
      key: index,
      attrs: {
        "error": "",
        "size": "large",
        "label": "点击跳转:",
        "value": item,
        "readonly": ""
      },
      on: {
        "click": function($event) {
          return _vm.open(item)
        }
      }
    })
  }), 1), _vm._v(" "), (this.sfxs === 2) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "备注信息:",
      "value": _vm.tanchukuang.message,
      "readonly": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dianzan(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": " 点赞照片:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.likedfile),
            callback: function($$v) {
              _vm.likedfile = $$v
            },
            expression: "likedfile"
          }
        })]
      },
      proxy: true
    }], null, false, 2193490940)
  }) : _vm._e(), _vm._v(" "), (_vm.zaikan(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": " 在看照片:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.watchingfile),
            callback: function($$v) {
              _vm.watchingfile = $$v
            },
            expression: "watchingfile"
          }
        })]
      },
      proxy: true
    }], null, false, 4171700634)
  }) : _vm._e(), _vm._v(" "), (_vm.zhuangfa(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": " 转发照片:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.transmitfile),
            callback: function($$v) {
              _vm.transmitfile = $$v
            },
            expression: "transmitfile"
          }
        })]
      },
      proxy: true
    }], null, false, 684305561)
  }) : _vm._e(), _vm._v(" "), (_vm.pinglun(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": " 评论照片:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.commentfile),
            callback: function($$v) {
              _vm.commentfile = $$v
            },
            expression: "commentfile"
          }
        })]
      },
      proxy: true
    }], null, false, 2709869664)
  }) : _vm._e(), _vm._v(" "), (_vm.jubao(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": " 举报照片:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.reportfile),
            callback: function($$v) {
              _vm.reportfile = $$v
            },
            expression: "reportfile"
          }
        })]
      },
      proxy: true
    }], null, false, 3331167549)
  }) : _vm._e(), _vm._v(" "), (_vm.guanzhu(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": " 关注照片:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.gzfile),
            callback: function($$v) {
              _vm.gzfile = $$v
            },
            expression: "gzfile"
          }
        })]
      },
      proxy: true
    }], null, false, 3001380174)
  }) : _vm._e(), _vm._v(" "), (_vm.toupiao(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": " 投票照片:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.tpfile),
            callback: function($$v) {
              _vm.tpfile = $$v
            },
            expression: "tpfile"
          }
        })]
      },
      proxy: true
    }], null, false, 610093111)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(this.sfxs === 2) ? _c('van-button', {
    staticStyle: {
      "width": "100px",
      "height": "40px",
      "margin-top": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.tiao(_vm.tanchukuang.title, _vm.tanchukuang.id, _vm.tanchukuang.demand, _vm.tanchukuang.bumen, _vm.urls)
      }
    }
  }, [_vm._v("提交任务")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zx-task-box-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(185)
    }
  })])
}]}

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "weui-tabbar__item",
    class: {
      'weui-bar__item_on': _vm.isActive,
      'vux-tabbar-simple': _vm.simple
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.onItemClick(true)
      }
    }
  }, [(!_vm.simple) ? _c('div', {
    staticClass: "weui-tabbar__icon",
    class: [_vm.iconClass || _vm.$parent.iconClass, {
      'vux-reddot': _vm.showDot
    }]
  }, [(!_vm.simple && !(_vm.hasActiveIcon && _vm.isActive)) ? _vm._t("icon") : _vm._e(), _vm._v(" "), (!_vm.simple && _vm.hasActiveIcon && _vm.isActive) ? _vm._t("icon-active") : _vm._e(), _vm._v(" "), (_vm.badge) ? _c('sup', [_c('badge', {
    attrs: {
      "text": _vm.badge
    }
  })], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "weui-tabbar__label"
  }, [_vm._t("label")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activityIndex page"
  }, [_c('div', {
    staticClass: "sy-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "task"
  }, [_c('div', {
    staticClass: "task-box",
    on: {
      "click": function($event) {
        return _vm.task('待完任务')
      }
    }
  }, [_c('div', {
    staticClass: "task-bg-1"
  }), _vm._v(" "), _c('span', [_vm._v("待完任务")]), _vm._v(" "), _c('div', {
    staticClass: "van-info-my"
  }, [_vm._v(_vm._s(_vm.daiwannum))])]), _vm._v(" "), _c('div', {
    staticClass: "task-box",
    on: {
      "click": function($event) {
        return _vm.task('审核任务')
      }
    }
  }, [_c('div', {
    staticClass: "task-bg-5"
  }), _vm._v(" "), _c('span', [_vm._v("审核任务")]), _vm._v(" "), _c('div', {
    staticClass: "van-info-my"
  }, [_vm._v(_vm._s(_vm.shenghenum))])]), _vm._v(" "), _c('div', {
    staticClass: "task-box",
    on: {
      "click": function($event) {
        return _vm.task('已完任务')
      }
    }
  }, [_c('div', {
    staticClass: "task-bg-2"
  }), _vm._v(" "), _c('span', [_vm._v("已完任务")]), _vm._v(" "), _c('div', {
    staticClass: "van-info-my"
  }, [_vm._v(_vm._s(_vm.yiwannum))])]), _vm._v(" "), _c('div', {
    staticClass: "task-box",
    on: {
      "click": function($event) {
        return _vm.task('超期任务')
      }
    }
  }, [_c('div', {
    staticClass: "task-bg-3"
  }), _vm._v(" "), _c('span', [_vm._v("超期任务")]), _vm._v(" "), _c('div', {
    staticClass: "van-info-my"
  }, [_vm._v(_vm._s(_vm.chaoqinum))])]), _vm._v(" "), _c('div', {
    staticClass: "task-box",
    on: {
      "click": function($event) {
        return _vm.task('退回任务')
      }
    }
  }, [_c('div', {
    staticClass: "task-bg-4"
  }), _vm._v(" "), _c('span', [_vm._v("退回任务")]), _vm._v(" "), _c('div', {
    staticClass: "van-info-my"
  }, [_vm._v(_vm._s(_vm.tuihuinum))])])]), _vm._v(" "), _c('div', {
    staticClass: "zx-task"
  }, [_c('div', [_c('h4', [_vm._v("最新任务")]), _vm._v(" "), _vm._l((_vm.totalData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zx-task-box",
      on: {
        "click": function($event) {
          return _vm.listDes(item)
        }
      }
    }, [_c('div', {
      staticClass: "zx-task-box-title"
    }, [_c('div', [(item.demand.includes('点赞')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "success"
      }
    }, [_vm._v(" 点赞  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('转发')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_vm._v(" 转发  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('在看')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "success",
        "color": "blue"
      }
    }, [_vm._v(" 在看  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('评论')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "warning",
        "color": "grey"
      }
    }, [_vm._v(" 评论  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('举报')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "warning",
        "color": "grey"
      }
    }, [_vm._v(" 举报  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('关注')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "warning",
        "color": "grey"
      }
    }, [_vm._v(" 关注  ")])], 1) : _vm._e(), _vm._v(" "), (item.demand.includes('投票')) ? _c('div', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      }
    }, [_c('van-tag', {
      attrs: {
        "type": "warning",
        "color": "grey"
      }
    }, [_vm._v(" 投票  ")])], 1) : _vm._e()]), _vm._v(" "), _c('br')]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "zx-task-box-des"
    }, [_vm._v("\n              任务名称："), _c('div', {
      staticStyle: {
        "color": "grey",
        "margin-bottom": "1px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" \n              结束时间："), _c('div', {
      staticStyle: {
        "color": "grey",
        "margin-bottom": "10px"
      }
    }, [_vm._v(" " + _vm._s(item.endtime))])])])
  })], 2)]), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "任务详情"
    },
    model: {
      value: (_vm.infoShow),
      callback: function($$v) {
        _vm.infoShow = $$v
      },
      expression: "infoShow"
    }
  }, [_c('van-cell-group', {
    staticClass: "asd",
    style: (_vm.test)
  }, [_c('van-field', {
    attrs: {
      "size": "large",
      "label-class": "label",
      "label": "任务名称:",
      "value": _vm.tanchukuang.title,
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "size": "large",
      "label": "开始时间:",
      "value": _vm.tanchukuang.starttime,
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "size": "large",
      "label": "结束时间:",
      "value": _vm.tanchukuang.endtime,
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "size": "large",
      "label": "备注信息:",
      "value": _vm.tanchukuang.message,
      "readonly": ""
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "size": "large",
      "label": "任务需求:",
      "value": _vm.tanchukuang.demand,
      "readonly": ""
    }
  }), _vm._v(" "), _c('div', _vm._l((_vm.urls), function(item, index) {
    return _c('van-field', {
      key: index,
      attrs: {
        "error": "",
        "label": "跳转链接：",
        "value": item,
        "readonly": ""
      },
      on: {
        "click": function($event) {
          return _vm.open(item)
        }
      }
    })
  }), 1), _vm._v(" "), (_vm.dianzan(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "点赞示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist),
            callback: function($$v) {
              _vm.filelist = $$v
            },
            expression: "filelist"
          }
        })]
      },
      proxy: true
    }], null, false, 2136404113)
  }) : _vm._e(), _vm._v(" "), (_vm.zaikan(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "在看示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist1),
            callback: function($$v) {
              _vm.filelist1 = $$v
            },
            expression: "filelist1"
          }
        })]
      },
      proxy: true
    }], null, false, 2313403904)
  }) : _vm._e(), _vm._v(" "), (_vm.zhuangfa(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "转发示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist2),
            callback: function($$v) {
              _vm.filelist2 = $$v
            },
            expression: "filelist2"
          }
        })]
      },
      proxy: true
    }], null, false, 4142773635)
  }) : _vm._e(), _vm._v(" "), (_vm.pinglun(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "评论示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist3),
            callback: function($$v) {
              _vm.filelist3 = $$v
            },
            expression: "filelist3"
          }
        })]
      },
      proxy: true
    }], null, false, 393317890)
  }) : _vm._e(), _vm._v(" "), (_vm.jubao(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "举报示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist4),
            callback: function($$v) {
              _vm.filelist4 = $$v
            },
            expression: "filelist4"
          }
        })]
      },
      proxy: true
    }], null, false, 593878405)
  }) : _vm._e(), _vm._v(" "), (_vm.guanzhu(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "关注示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist5),
            callback: function($$v) {
              _vm.filelist5 = $$v
            },
            expression: "filelist5"
          }
        })]
      },
      proxy: true
    }], null, false, 2974227716)
  }) : _vm._e(), _vm._v(" "), (_vm.toupiao(_vm.tanchukuang.demand)) ? _c('van-field', {
    attrs: {
      "size": "large",
      "label": "投票示例:",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "deletable": false,
            "multiple": "",
            "after-read": _vm.afterRead,
            "max-count": 1
          },
          model: {
            value: (_vm.filelist6),
            callback: function($$v) {
              _vm.filelist6 = $$v
            },
            expression: "filelist6"
          }
        })]
      },
      proxy: true
    }], null, false, 508630151)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('van-button', {
    staticStyle: {
      "width": "100px",
      "height": "40px",
      "margin-top": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.tiao(_vm.tanchukuang.title, _vm.tanchukuang.id, _vm.tanchukuang.demand, _vm.tanchukuang.bumen, _vm.urls)
      }
    }
  }, [_vm._v("提交任务")])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zx-task-box-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(185)
    }
  })])
}]}

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "clas": "mine"
    }
  }, [_c('h1', [_vm._v("我的")])])
}]}

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(405)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(536),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(395)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(526),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(399)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(530),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(404)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(535),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(397)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(528),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(406)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(537),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(408)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(539),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(411)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(543),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(7)(
  /* script */
  null,
  /* template */
  __webpack_require__(544),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(410)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(541),
  /* scopeId */
  "data-v-b415fb4e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(409)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(540),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(400)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(531),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(393)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(524),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(398)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(529),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(403)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(534),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(396)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(527),
  /* scopeId */
  "data-v-1480a40e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(407)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(538),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(394)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(525),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[279]);


// WEBPACK FOOTER //
// static/js/app.479a6239da3dc73c33bd.js